const sn = "2.0.0", Et = "https://front.bucket.co", an = "https://livemessaging.bucket.co", et = "bucket-sdk-version", cn = `browser-sdk/${sn}`, ln = 1, un = {
  debug(t) {
  },
  info(t) {
  },
  warn(t, ...e) {
    console.warn(t, ...e);
  },
  error(t, ...e) {
    console.error(t, ...e);
  }
};
function Ve(t, e) {
  return {
    debug(n, ...o) {
      t.debug(`${e} ${n}`, ...o);
    },
    info(n, ...o) {
      t.info(`${e} ${n}`, ...o);
    },
    warn(n, ...o) {
      t.warn(`${e} ${n}`, ...o);
    },
    error(n, ...o) {
      t.error(`${e} ${n}`, ...o);
    }
  };
}
const dn = 60 * 1e3;
class fn {
  constructor(e, n) {
    this.eventsPerMinute = e, this.logger = n, this.eventsByKey = {};
  }
  rateLimited(e, n) {
    const o = Date.now();
    this.eventsByKey[e] || (this.eventsByKey[e] = []);
    const r = this.eventsByKey[e];
    for (; r.length && o - r[0] > dn; )
      r.shift();
    if (r.length >= this.eventsPerMinute) {
      this.logger.debug("Rate limit exceeded", { key: e });
      return;
    }
    return r.push(o), n();
  }
}
function Rt(t) {
  if (!ae(t))
    return;
  const e = {};
  for (const n in t) {
    const o = t[n];
    if (typeof o.isEnabled != "boolean" || o.key !== n || typeof o.targetingVersion != "number")
      return;
    e[n] = {
      isEnabled: o.isEnabled,
      targetingVersion: o.targetingVersion,
      key: n
    };
  }
  return e;
}
class hn {
  constructor({
    storage: e,
    staleTimeMs: n,
    expireTimeMs: o
  }) {
    this.storage = e, this.staleTimeMs = n, this.expireTimeMs = o;
  }
  set(e, {
    features: n
  }) {
    let o = {};
    try {
      const r = this.storage.get();
      r && (o = tt(JSON.parse(r)) ?? {});
    } catch {
    }
    return o[e] = {
      expireAt: Date.now() + this.expireTimeMs,
      staleAt: Date.now() + this.staleTimeMs,
      features: n
    }, o = Object.fromEntries(
      Object.entries(o).filter(([r, i]) => i.expireAt > Date.now())
    ), this.storage.set(JSON.stringify(o)), o;
  }
  get(e) {
    try {
      const n = this.storage.get();
      if (n) {
        const o = tt(JSON.parse(n));
        if (o && o[e] && o[e].expireAt > Date.now())
          return {
            features: o[e].features,
            stale: o[e].staleAt < Date.now()
          };
      }
    } catch {
    }
  }
}
function tt(t) {
  if (!ae(t))
    return;
  const e = {};
  for (const n in t) {
    const o = t[n];
    if (!ae(o) || typeof o.expireAt != "number" || typeof o.staleAt != "number" || o.features && !Rt(o.features))
      return;
    e[n] = {
      expireAt: o.expireAt,
      staleAt: o.staleAt,
      features: o.features
    };
  }
  return e;
}
function ae(t) {
  return t && typeof t == "object" && !Array.isArray(t);
}
const pn = {
  fallbackFeatures: [],
  timeoutMs: 5e3,
  staleWhileRevalidate: !1
};
function gn(t) {
  if (!ae(t) || typeof t.success != "boolean" || !ae(t.features))
    return;
  const e = Rt(t.features);
  if (e)
    return {
      success: t.success,
      features: e
    };
}
function It(t) {
  const e = {};
  for (const n in t)
    if (typeof t[n] == "object") {
      const o = It(t[n]);
      for (const r in o)
        e[`${n}.${r}`] = o[r];
    } else {
      if (typeof t[n] > "u")
        continue;
      e[n] = t[n];
    }
  return e;
}
const _n = 6e4, mn = 30 * 24 * 60 * 60 * 1e3, nt = "__bucket_features";
class bn {
  constructor(e, n, o, r) {
    this.httpClient = e, this.context = n, this.features = {}, this.logger = Ve(o, "[Features]"), this.cache = r != null && r.cache ? r.cache : new hn({
      storage: {
        get: () => localStorage.getItem(nt),
        set: (i) => localStorage.setItem(nt, i)
      },
      staleTimeMs: _n,
      expireTimeMs: mn
    }), this.config = { ...pn, ...r }, this.rateLimiter = (r == null ? void 0 : r.rateLimiter) ?? new fn(ln, this.logger);
  }
  async initialize() {
    const e = await this.maybeFetchFeatures() || {};
    this.setFeatures(e);
  }
  setFeatures(e) {
    this.features = e;
  }
  getFeatures() {
    return this.features;
  }
  fetchParams() {
    const e = It({ context: this.context }), n = new URLSearchParams(e);
    return n.append("publishableKey", this.httpClient.publishableKey), n.sort(), n;
  }
  async maybeFetchFeatures() {
    const e = this.fetchParams().toString(), n = this.cache.get(e);
    if (n) {
      if (!n.stale) return n.features;
      if (this.config.staleWhileRevalidate)
        return this.fetchFeatures().then((r) => {
          r && (this.cache.set(e, {
            features: r
          }), this.setFeatures(r));
        }).catch(() => {
        }), n.features;
    }
    const o = await this.fetchFeatures();
    return o ? (this.cache.set(e, {
      features: o
    }), o) : n ? n.features : this.config.fallbackFeatures.reduce((r, i) => (r[i] = {
      key: i,
      isEnabled: !0
    }, r), {});
  }
  async fetchFeatures() {
    const e = this.fetchParams();
    try {
      const n = await this.httpClient.get({
        path: "/features/enabled",
        timeoutMs: this.config.timeoutMs,
        params: e
      });
      if (!n.ok) {
        let r = null;
        try {
          r = await n.json();
        } catch {
        }
        throw new Error(
          "unexpected response code: " + n.status + " - " + JSON.stringify(r)
        );
      }
      const o = gn(await n.json());
      if (!o || !o.success)
        throw new Error("unable to validate response");
      return o.features;
    } catch (n) {
      this.logger.error("error fetching features: ", n);
      return;
    }
  }
  /**
   * Send a feature "check" event.
   *
   *
   * @param checkEvent - The feature to send the event for.
   */
  async sendCheckEvent(e) {
    const n = `${this.fetchParams().toString()}:${e.key}:${e.version}:${e.value}`;
    return await this.rateLimiter.rateLimited(n, async () => {
      const o = {
        action: "check",
        key: e.key,
        targetingVersion: e.version,
        evalContext: this.context,
        evalResult: e.value
      };
      this.httpClient.post({
        path: "features/events",
        body: o
      }).catch((r) => {
        this.logger.warn("failed to send feature check event", r);
      }), this.logger.debug("sent feature event", o);
    }), e.value;
  }
}
/*! js-cookie v3.0.5 | MIT */
function he(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var o in n)
      t[o] = n[o];
  }
  return t;
}
var yn = {
  read: function(t) {
    return t[0] === '"' && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(t) {
    return encodeURIComponent(t).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function Oe(t, e) {
  function n(r, i, s) {
    if (!(typeof document > "u")) {
      s = he({}, e, s), typeof s.expires == "number" && (s.expires = new Date(Date.now() + s.expires * 864e5)), s.expires && (s.expires = s.expires.toUTCString()), r = encodeURIComponent(r).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var c = "";
      for (var u in s)
        s[u] && (c += "; " + u, s[u] !== !0 && (c += "=" + s[u].split(";")[0]));
      return document.cookie = r + "=" + t.write(i, r) + c;
    }
  }
  function o(r) {
    if (!(typeof document > "u" || arguments.length && !r)) {
      for (var i = document.cookie ? document.cookie.split("; ") : [], s = {}, c = 0; c < i.length; c++) {
        var u = i[c].split("="), l = u.slice(1).join("=");
        try {
          var f = decodeURIComponent(u[0]);
          if (s[f] = t.read(l, f), r === f)
            break;
        } catch {
        }
      }
      return r ? s[r] : s;
    }
  }
  return Object.create(
    {
      set: n,
      get: o,
      remove: function(r, i) {
        n(
          r,
          "",
          he({}, i, {
            expires: -1
          })
        );
      },
      withAttributes: function(r) {
        return Oe(this.converter, he({}, this.attributes, r));
      },
      withConverter: function(r) {
        return Oe(he({}, this.converter, r), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(e) },
      converter: { value: Object.freeze(t) }
    }
  );
}
var de = Oe(yn, { path: "/" });
const vn = (t, e, n) => {
  de.set(`bucket-prompt-${t}`, e, {
    expires: n,
    sameSite: "strict",
    secure: !0
  });
}, wn = (t, e) => de.get(`bucket-prompt-${t}`) === e, xn = (t, e, n, o) => {
  de.set(`bucket-token-${t}`, JSON.stringify({ channel: e, token: n }), {
    expires: o,
    sameSite: "strict",
    secure: !0
  });
}, Lt = (t) => {
  const e = de.get(`bucket-token-${t}`);
  if (e)
    try {
      const { channel: n, token: o } = JSON.parse(e);
      return !(n != null && n.length) || !(o != null && o.length) ? void 0 : {
        channel: n,
        token: o
      };
    } catch {
      return;
    }
}, kn = (t) => {
  de.remove(`bucket-token-${t}`);
}, Cn = 4e4, Sn = 49999;
class En {
  constructor(e, n, o, r, i, s) {
    this.userId = e, this.channel = n, this.sseHost = o, this.messageHandler = r, this.httpClient = i, this.isOpen = !1, this.eventSource = null, this.retryInterval = null, this.logger = Ve(s, "[SSE]");
  }
  async refreshTokenRequest() {
    const e = new URLSearchParams({ userId: this.userId }), n = await this.httpClient.get({
      path: "/feedback/prompting-auth",
      params: e
    });
    if (n.ok) {
      const o = await n.json();
      if (o.success) {
        delete o.success;
        const r = o;
        return this.logger.debug("obtained new token request", r), r;
      }
    }
    this.logger.error("server did not release a token request", n);
  }
  async refreshToken() {
    const e = Lt(this.userId);
    if (e && e.channel === this.channel)
      return this.logger.debug("using existing token", e.channel, e.token), e.token;
    const n = await this.refreshTokenRequest();
    if (!n)
      return;
    const o = new URL(
      `/keys/${encodeURIComponent(n.keyName)}/requestToken`,
      this.sseHost
    ), r = await fetch(o, {
      method: "post",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(n)
    });
    if (r.ok) {
      const i = await r.json();
      return this.logger.debug("obtained new token", i), xn(
        this.userId,
        this.channel,
        i.token,
        new Date(i.expires)
      ), i.token;
    }
    this.logger.error("server did not release a token");
  }
  async onError(e) {
    var n;
    if (e instanceof MessageEvent) {
      let o;
      try {
        const r = JSON.parse(e.data);
        o = (r == null ? void 0 : r.code) && Number(r.code);
      } catch (r) {
        this.logger.warn("received unparsable error message", r, e);
      }
      o && o >= Cn && o <= Sn && (this.logger.warn("event source token expired, refresh required"), kn(this.userId));
    } else {
      const o = (n = e == null ? void 0 : e.target) == null ? void 0 : n.readyState;
      o === 2 ? this.logger.debug("event source connection closed", e) : o === 1 ? this.logger.warn("event source connection failed to open", e) : this.logger.warn("event source unexpected error occurred", e);
    }
    this.disconnect();
  }
  onMessage(e) {
    let n;
    try {
      if (e.data) {
        const o = JSON.parse(e.data);
        o.data && (n = JSON.parse(o.data));
      }
    } catch (o) {
      this.logger.warn("received unparsable message", o, e);
      return;
    }
    if (n) {
      this.logger.debug("received message", n);
      try {
        this.messageHandler(n);
      } catch (o) {
        this.logger.warn("failed to handle message", o, n);
      }
      return;
    }
    this.logger.warn("received invalid message", e);
  }
  onOpen(e) {
    this.logger.debug("event source connection opened", e);
  }
  async connect() {
    if (this.isOpen) {
      this.logger.warn("channel connection already open");
      return;
    }
    this.isOpen = !0;
    try {
      const e = await this.refreshToken();
      if (!e) return;
      const n = new URL("/sse", this.sseHost);
      n.searchParams.append("v", "1.2"), n.searchParams.append("accessToken", e), n.searchParams.append("channels", this.channel), n.searchParams.append("rewind", "1"), this.eventSource = new EventSource(n), this.eventSource.addEventListener("error", (o) => this.onError(o)), this.eventSource.addEventListener("open", (o) => this.onOpen(o)), this.eventSource.addEventListener("message", (o) => this.onMessage(o)), this.logger.debug("channel connection opened");
    } finally {
      this.isOpen = !!this.eventSource;
    }
  }
  disconnect() {
    if (!this.isOpen) {
      this.logger.warn("channel connection already closed");
      return;
    }
    this.eventSource && (this.eventSource.close(), this.eventSource = null, this.logger.debug("channel connection closed")), this.isOpen = !1;
  }
  open(e) {
    const n = (e == null ? void 0 : e.retryInterval) ?? 3e4, o = (e == null ? void 0 : e.retryCount) ?? 3;
    let r = o;
    const i = async () => {
      try {
        await this.connect(), r = o;
      } catch (s) {
        r > 0 ? this.logger.warn(
          `failed to connect, ${r} retries remaining`,
          s
        ) : this.logger.warn("failed to connect, no retries remaining", s);
      }
    };
    i(), this.retryInterval = setInterval(() => {
      if (!this.isConnected() && this.retryInterval) {
        if (r <= 0) {
          clearInterval(this.retryInterval), this.retryInterval = null;
          return;
        }
        r--, i();
      }
    }, n);
  }
  close() {
    this.retryInterval && (clearInterval(this.retryInterval), this.retryInterval = null), this.disconnect();
  }
  isActive() {
    return !!this.retryInterval;
  }
  isConnected() {
    return this.isOpen && !!this.eventSource;
  }
}
function Rn({
  userId: t,
  channel: e,
  callback: n,
  httpClient: o,
  sseHost: r,
  logger: i
}) {
  const s = new En(
    t,
    e,
    r,
    n,
    o,
    i
  );
  return s.open(), s;
}
const In = (t) => {
  if (!(typeof (t == null ? void 0 : t.question) != "string" || !t.question.length || typeof t.showAfter != "number" || typeof t.showBefore != "number" || typeof t.promptId != "string" || !t.promptId.length || typeof t.featureId != "string" || !t.featureId.length))
    return {
      question: t.question,
      showAfter: new Date(t.showAfter),
      showBefore: new Date(t.showBefore),
      promptId: t.promptId,
      featureId: t.featureId
    };
}, Ln = (t, e, n) => {
  const o = /* @__PURE__ */ new Date(), r = () => {
    vn(t, e.promptId, e.showBefore);
  };
  return wn(t, e.promptId) || o > e.showBefore ? !1 : o < e.showAfter ? (setTimeout(() => {
    n(t, e, r);
  }, e.showAfter.getTime() - o.getTime()), !0) : (n(t, e, r), !0);
};
var Ce, E, At, J, ot, Tt, Pe, We, Ne, $e, ce = {}, Ft = [], An = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, qe = Array.isArray;
function Z(t, e) {
  for (var n in e) t[n] = e[n];
  return t;
}
function Dt(t) {
  var e = t.parentNode;
  e && e.removeChild(t);
}
function h(t, e, n) {
  var o, r, i, s = {};
  for (i in e) i == "key" ? o = e[i] : i == "ref" ? r = e[i] : s[i] = e[i];
  if (arguments.length > 2 && (s.children = arguments.length > 3 ? Ce.call(arguments, 2) : n), typeof t == "function" && t.defaultProps != null) for (i in t.defaultProps) s[i] === void 0 && (s[i] = t.defaultProps[i]);
  return _e(t, s, o, r, null);
}
function _e(t, e, n, o, r) {
  var i = { type: t, props: e, key: n, ref: o, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, constructor: void 0, __v: r ?? ++At, __i: -1, __u: 0 };
  return r == null && E.vnode != null && E.vnode(i), i;
}
function ie(t) {
  return t.children;
}
function me(t, e) {
  this.props = t, this.context = e;
}
function X(t, e) {
  if (e == null) return t.__ ? X(t.__, t.__i + 1) : null;
  for (var n; e < t.__k.length; e++) if ((n = t.__k[e]) != null && n.__e != null) return n.__e;
  return typeof t.type == "function" ? X(t) : null;
}
function Mt(t) {
  var e, n;
  if ((t = t.__) != null && t.__c != null) {
    for (t.__e = t.__c.base = null, e = 0; e < t.__k.length; e++) if ((n = t.__k[e]) != null && n.__e != null) {
      t.__e = t.__c.base = n.__e;
      break;
    }
    return Mt(t);
  }
}
function rt(t) {
  (!t.__d && (t.__d = !0) && J.push(t) && !ve.__r++ || ot !== E.debounceRendering) && ((ot = E.debounceRendering) || Tt)(ve);
}
function ve() {
  var t, e, n, o, r, i, s, c;
  for (J.sort(Pe); t = J.shift(); ) t.__d && (e = J.length, o = void 0, i = (r = (n = t).__v).__e, s = [], c = [], n.__P && ((o = Z({}, r)).__v = r.__v + 1, E.vnode && E.vnode(o), je(n.__P, o, r, n.__n, n.__P.namespaceURI, 32 & r.__u ? [i] : null, s, i ?? X(r), !!(32 & r.__u), c), o.__v = r.__v, o.__.__k[o.__i] = o, Nt(s, o, c), o.__e != i && Mt(o)), J.length > e && J.sort(Pe));
  ve.__r = 0;
}
function Ot(t, e, n, o, r, i, s, c, u, l, f) {
  var a, p, d, m, y, _ = o && o.__k || Ft, g = e.length;
  for (n.__d = u, Tn(n, e, _), u = n.__d, a = 0; a < g; a++) (d = n.__k[a]) != null && typeof d != "boolean" && typeof d != "function" && (p = d.__i === -1 ? ce : _[d.__i] || ce, d.__i = a, je(t, d, p, r, i, s, c, u, l, f), m = d.__e, d.ref && p.ref != d.ref && (p.ref && Ze(p.ref, null, d), f.push(d.ref, d.__c || m, d)), y == null && m != null && (y = m), 65536 & d.__u || p.__k === d.__k ? (u && typeof d.type == "string" && !t.contains(u) && (u = X(p)), u = Pt(d, u, t)) : typeof d.type == "function" && d.__d !== void 0 ? u = d.__d : m && (u = m.nextSibling), d.__d = void 0, d.__u &= -196609);
  n.__d = u, n.__e = y;
}
function Tn(t, e, n) {
  var o, r, i, s, c, u = e.length, l = n.length, f = l, a = 0;
  for (t.__k = [], o = 0; o < u; o++) s = o + a, (r = t.__k[o] = (r = e[o]) == null || typeof r == "boolean" || typeof r == "function" ? null : typeof r == "string" || typeof r == "number" || typeof r == "bigint" || r.constructor == String ? _e(null, r, null, null, null) : qe(r) ? _e(ie, { children: r }, null, null, null) : r.constructor === void 0 && r.__b > 0 ? _e(r.type, r.props, r.key, r.ref ? r.ref : null, r.__v) : r) != null ? (r.__ = t, r.__b = t.__b + 1, c = Fn(r, n, s, f), r.__i = c, i = null, c !== -1 && (f--, (i = n[c]) && (i.__u |= 131072)), i == null || i.__v === null ? (c == -1 && a--, typeof r.type != "function" && (r.__u |= 65536)) : c !== s && (c == s - 1 ? a = c - s : c == s + 1 ? a++ : c > s ? f > u - s ? a += c - s : a-- : c < s && a++, c !== o + a && (r.__u |= 65536))) : (i = n[s]) && i.key == null && i.__e && !(131072 & i.__u) && (i.__e == t.__d && (t.__d = X(i)), He(i, i, !1), n[s] = null, f--);
  if (f) for (o = 0; o < l; o++) (i = n[o]) != null && !(131072 & i.__u) && (i.__e == t.__d && (t.__d = X(i)), He(i, i));
}
function Pt(t, e, n) {
  var o, r;
  if (typeof t.type == "function") {
    for (o = t.__k, r = 0; o && r < o.length; r++) o[r] && (o[r].__ = t, e = Pt(o[r], e, n));
    return e;
  }
  t.__e != e && (n.insertBefore(t.__e, e || null), e = t.__e);
  do
    e = e && e.nextSibling;
  while (e != null && e.nodeType === 8);
  return e;
}
function Fn(t, e, n, o) {
  var r = t.key, i = t.type, s = n - 1, c = n + 1, u = e[n];
  if (u === null || u && r == u.key && i === u.type && !(131072 & u.__u)) return n;
  if (o > (u != null && !(131072 & u.__u) ? 1 : 0)) for (; s >= 0 || c < e.length; ) {
    if (s >= 0) {
      if ((u = e[s]) && !(131072 & u.__u) && r == u.key && i === u.type) return s;
      s--;
    }
    if (c < e.length) {
      if ((u = e[c]) && !(131072 & u.__u) && r == u.key && i === u.type) return c;
      c++;
    }
  }
  return -1;
}
function it(t, e, n) {
  e[0] === "-" ? t.setProperty(e, n ?? "") : t[e] = n == null ? "" : typeof n != "number" || An.test(e) ? n : n + "px";
}
function pe(t, e, n, o, r) {
  var i;
  e: if (e === "style") if (typeof n == "string") t.style.cssText = n;
  else {
    if (typeof o == "string" && (t.style.cssText = o = ""), o) for (e in o) n && e in n || it(t.style, e, "");
    if (n) for (e in n) o && n[e] === o[e] || it(t.style, e, n[e]);
  }
  else if (e[0] === "o" && e[1] === "n") i = e !== (e = e.replace(/(PointerCapture)$|Capture$/i, "$1")), e = e.toLowerCase() in t || e === "onFocusOut" || e === "onFocusIn" ? e.toLowerCase().slice(2) : e.slice(2), t.l || (t.l = {}), t.l[e + i] = n, n ? o ? n.u = o.u : (n.u = We, t.addEventListener(e, i ? $e : Ne, i)) : t.removeEventListener(e, i ? $e : Ne, i);
  else {
    if (r == "http://www.w3.org/2000/svg") e = e.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
    else if (e != "width" && e != "height" && e != "href" && e != "list" && e != "form" && e != "tabIndex" && e != "download" && e != "rowSpan" && e != "colSpan" && e != "role" && e != "popover" && e in t) try {
      t[e] = n ?? "";
      break e;
    } catch {
    }
    typeof n == "function" || (n == null || n === !1 && e[4] !== "-" ? t.removeAttribute(e) : t.setAttribute(e, e == "popover" && n == 1 ? "" : n));
  }
}
function st(t) {
  return function(e) {
    if (this.l) {
      var n = this.l[e.type + t];
      if (e.t == null) e.t = We++;
      else if (e.t < n.u) return;
      return n(E.event ? E.event(e) : e);
    }
  };
}
function je(t, e, n, o, r, i, s, c, u, l) {
  var f, a, p, d, m, y, _, g, b, v, w, x, C, A, T, D, S = e.type;
  if (e.constructor !== void 0) return null;
  128 & n.__u && (u = !!(32 & n.__u), i = [c = e.__e = n.__e]), (f = E.__b) && f(e);
  e: if (typeof S == "function") try {
    if (g = e.props, b = "prototype" in S && S.prototype.render, v = (f = S.contextType) && o[f.__c], w = f ? v ? v.props.value : f.__ : o, n.__c ? _ = (a = e.__c = n.__c).__ = a.__E : (b ? e.__c = a = new S(g, w) : (e.__c = a = new me(g, w), a.constructor = S, a.render = Mn), v && v.sub(a), a.props = g, a.state || (a.state = {}), a.context = w, a.__n = o, p = a.__d = !0, a.__h = [], a._sb = []), b && a.__s == null && (a.__s = a.state), b && S.getDerivedStateFromProps != null && (a.__s == a.state && (a.__s = Z({}, a.__s)), Z(a.__s, S.getDerivedStateFromProps(g, a.__s))), d = a.props, m = a.state, a.__v = e, p) b && S.getDerivedStateFromProps == null && a.componentWillMount != null && a.componentWillMount(), b && a.componentDidMount != null && a.__h.push(a.componentDidMount);
    else {
      if (b && S.getDerivedStateFromProps == null && g !== d && a.componentWillReceiveProps != null && a.componentWillReceiveProps(g, w), !a.__e && (a.shouldComponentUpdate != null && a.shouldComponentUpdate(g, a.__s, w) === !1 || e.__v === n.__v)) {
        for (e.__v !== n.__v && (a.props = g, a.state = a.__s, a.__d = !1), e.__e = n.__e, e.__k = n.__k, e.__k.forEach(function(O) {
          O && (O.__ = e);
        }), x = 0; x < a._sb.length; x++) a.__h.push(a._sb[x]);
        a._sb = [], a.__h.length && s.push(a);
        break e;
      }
      a.componentWillUpdate != null && a.componentWillUpdate(g, a.__s, w), b && a.componentDidUpdate != null && a.__h.push(function() {
        a.componentDidUpdate(d, m, y);
      });
    }
    if (a.context = w, a.props = g, a.__P = t, a.__e = !1, C = E.__r, A = 0, b) {
      for (a.state = a.__s, a.__d = !1, C && C(e), f = a.render(a.props, a.state, a.context), T = 0; T < a._sb.length; T++) a.__h.push(a._sb[T]);
      a._sb = [];
    } else do
      a.__d = !1, C && C(e), f = a.render(a.props, a.state, a.context), a.state = a.__s;
    while (a.__d && ++A < 25);
    a.state = a.__s, a.getChildContext != null && (o = Z(Z({}, o), a.getChildContext())), b && !p && a.getSnapshotBeforeUpdate != null && (y = a.getSnapshotBeforeUpdate(d, m)), Ot(t, qe(D = f != null && f.type === ie && f.key == null ? f.props.children : f) ? D : [D], e, n, o, r, i, s, c, u, l), a.base = e.__e, e.__u &= -161, a.__h.length && s.push(a), _ && (a.__E = a.__ = null);
  } catch (O) {
    e.__v = null, u || i != null ? (e.__e = c, e.__u |= u ? 160 : 32, i[i.indexOf(c)] = null) : (e.__e = n.__e, e.__k = n.__k), E.__e(O, e, n);
  }
  else i == null && e.__v === n.__v ? (e.__k = n.__k, e.__e = n.__e) : e.__e = Dn(n.__e, e, n, o, r, i, s, u, l);
  (f = E.diffed) && f(e);
}
function Nt(t, e, n) {
  e.__d = void 0;
  for (var o = 0; o < n.length; o++) Ze(n[o], n[++o], n[++o]);
  E.__c && E.__c(e, t), t.some(function(r) {
    try {
      t = r.__h, r.__h = [], t.some(function(i) {
        i.call(r);
      });
    } catch (i) {
      E.__e(i, r.__v);
    }
  });
}
function Dn(t, e, n, o, r, i, s, c, u) {
  var l, f, a, p, d, m, y, _ = n.props, g = e.props, b = e.type;
  if (b === "svg" ? r = "http://www.w3.org/2000/svg" : b === "math" ? r = "http://www.w3.org/1998/Math/MathML" : r || (r = "http://www.w3.org/1999/xhtml"), i != null) {
    for (l = 0; l < i.length; l++) if ((d = i[l]) && "setAttribute" in d == !!b && (b ? d.localName === b : d.nodeType === 3)) {
      t = d, i[l] = null;
      break;
    }
  }
  if (t == null) {
    if (b === null) return document.createTextNode(g);
    t = document.createElementNS(r, b, g.is && g), i = null, c = !1;
  }
  if (b === null) _ === g || c && t.data === g || (t.data = g);
  else {
    if (i = i && Ce.call(t.childNodes), _ = n.props || ce, !c && i != null) for (_ = {}, l = 0; l < t.attributes.length; l++) _[(d = t.attributes[l]).name] = d.value;
    for (l in _) if (d = _[l], l != "children") {
      if (l == "dangerouslySetInnerHTML") a = d;
      else if (l !== "key" && !(l in g)) {
        if (l == "value" && "defaultValue" in g || l == "checked" && "defaultChecked" in g) continue;
        pe(t, l, null, d, r);
      }
    }
    for (l in g) d = g[l], l == "children" ? p = d : l == "dangerouslySetInnerHTML" ? f = d : l == "value" ? m = d : l == "checked" ? y = d : l === "key" || c && typeof d != "function" || _[l] === d || pe(t, l, d, _[l], r);
    if (f) c || a && (f.__html === a.__html || f.__html === t.innerHTML) || (t.innerHTML = f.__html), e.__k = [];
    else if (a && (t.innerHTML = ""), Ot(t, qe(p) ? p : [p], e, n, o, b === "foreignObject" ? "http://www.w3.org/1999/xhtml" : r, i, s, i ? i[0] : n.__k && X(n, 0), c, u), i != null) for (l = i.length; l--; ) i[l] != null && Dt(i[l]);
    c || (l = "value", m !== void 0 && (m !== t[l] || b === "progress" && !m || b === "option" && m !== _[l]) && pe(t, l, m, _[l], r), l = "checked", y !== void 0 && y !== t[l] && pe(t, l, y, _[l], r));
  }
  return t;
}
function Ze(t, e, n) {
  try {
    typeof t == "function" ? t(e) : t.current = e;
  } catch (o) {
    E.__e(o, n);
  }
}
function He(t, e, n) {
  var o, r;
  if (E.unmount && E.unmount(t), (o = t.ref) && (o.current && o.current !== t.__e || Ze(o, null, e)), (o = t.__c) != null) {
    if (o.componentWillUnmount) try {
      o.componentWillUnmount();
    } catch (i) {
      E.__e(i, e);
    }
    o.base = o.__P = null;
  }
  if (o = t.__k) for (r = 0; r < o.length; r++) o[r] && He(o[r], e, n || typeof t.type != "function");
  n || t.__e == null || Dt(t.__e), t.__c = t.__ = t.__e = t.__d = void 0;
}
function Mn(t, e, n) {
  return this.constructor(t, n);
}
function On(t, e, n) {
  var o, r, i, s;
  E.__ && E.__(t, e), r = (o = typeof n == "function") ? null : e.__k, i = [], s = [], je(e, t = (!o && n || e).__k = h(ie, null, [t]), r || ce, ce, e.namespaceURI, !o && n ? [n] : r ? null : e.firstChild ? Ce.call(e.childNodes) : null, i, !o && n ? n : r ? r.__e : e.firstChild, o, s), Nt(i, t, s);
}
Ce = Ft.slice, E = { __e: function(t, e, n, o) {
  for (var r, i, s; e = e.__; ) if ((r = e.__c) && !r.__) try {
    if ((i = r.constructor) && i.getDerivedStateFromError != null && (r.setState(i.getDerivedStateFromError(t)), s = r.__d), r.componentDidCatch != null && (r.componentDidCatch(t, o || {}), s = r.__d), s) return r.__E = r;
  } catch (c) {
    t = c;
  }
  throw t;
} }, At = 0, me.prototype.setState = function(t, e) {
  var n;
  n = this.__s != null && this.__s !== this.state ? this.__s : this.__s = Z({}, this.state), typeof t == "function" && (t = t(Z({}, n), this.props)), t && Z(n, t), t != null && this.__v && (e && this._sb.push(e), rt(this));
}, me.prototype.forceUpdate = function(t) {
  this.__v && (this.__e = !0, t && this.__h.push(t), rt(this));
}, me.prototype.render = ie, J = [], Tt = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, Pe = function(t, e) {
  return t.__v.__b - e.__v.__b;
}, ve.__r = 0, We = 0, Ne = st(!1), $e = st(!0);
const ze = "bucket-feedback-dialog-container", Pn = [
  "animationcancel",
  "animationend",
  "animationiteration",
  "animationstart",
  "afterscriptexecute",
  "auxclick",
  "beforescriptexecute",
  "blur",
  "click",
  "compositionend",
  "compositionstart",
  "compositionupdate",
  "contextmenu",
  "copy",
  "cut",
  "dblclick",
  "DOMActivate",
  "DOMMouseScroll",
  "error",
  "focusin",
  "focusout",
  "focus",
  "fullscreenchange",
  "fullscreenerror",
  "gesturechange",
  "gestureend",
  "gesturestart",
  "gotpointercapture",
  "keydown",
  "keypress",
  "keyup",
  "lostpointercapture",
  "mousedown",
  "mouseenter",
  "mouseleave",
  "mousemove",
  "mouseout",
  "mouseover",
  "mouseup",
  "mousewheel",
  "paste",
  "pointercancel",
  "pointerdown",
  "pointerenter",
  "pointerleave",
  "pointermove",
  "pointerout",
  "pointerover",
  "pointerup",
  "scroll",
  "select",
  "touchcancel",
  "touchend",
  "touchmove",
  "touchstart",
  "transitioncancel",
  "transitionend",
  "transitionrun",
  "transitionstart",
  "wheel"
];
var ne, I, Fe, at, le = 0, $t = [], L = E, ct = L.__b, lt = L.__r, ut = L.diffed, dt = L.__c, ft = L.unmount, ht = L.__;
function Se(t, e) {
  L.__h && L.__h(I, t, le || e), le = 0;
  var n = I.__H || (I.__H = { __: [], __h: [] });
  return t >= n.__.length && n.__.push({}), n.__[t];
}
function M(t) {
  return le = 1, Nn(Ht, t);
}
function Nn(t, e, n) {
  var o = Se(ne++, 2);
  if (o.t = t, !o.__c && (o.__ = [Ht(void 0, e), function(c) {
    var u = o.__N ? o.__N[0] : o.__[0], l = o.t(u, c);
    u !== l && (o.__N = [l, o.__[1]], o.__c.setState({}));
  }], o.__c = I, !I.u)) {
    var r = function(c, u, l) {
      if (!o.__c.__H) return !0;
      var f = o.__c.__H.__.filter(function(p) {
        return !!p.__c;
      });
      if (f.every(function(p) {
        return !p.__N;
      })) return !i || i.call(this, c, u, l);
      var a = !1;
      return f.forEach(function(p) {
        if (p.__N) {
          var d = p.__[0];
          p.__ = p.__N, p.__N = void 0, d !== p.__[0] && (a = !0);
        }
      }), !(!a && o.__c.props === c) && (!i || i.call(this, c, u, l));
    };
    I.u = !0;
    var i = I.shouldComponentUpdate, s = I.componentWillUpdate;
    I.componentWillUpdate = function(c, u, l) {
      if (this.__e) {
        var f = i;
        i = void 0, r(c, u, l), i = f;
      }
      s && s.call(this, c, u, l);
    }, I.shouldComponentUpdate = r;
  }
  return o.__N || o.__;
}
function Ee(t, e) {
  var n = Se(ne++, 3);
  !L.__s && Ke(n.__H, e) && (n.__ = t, n.i = e, I.__H.__h.push(n));
}
function be(t, e) {
  var n = Se(ne++, 4);
  !L.__s && Ke(n.__H, e) && (n.__ = t, n.i = e, I.__h.push(n));
}
function H(t) {
  return le = 5, ee(function() {
    return { current: t };
  }, []);
}
function ee(t, e) {
  var n = Se(ne++, 7);
  return Ke(n.__H, e) && (n.__ = t(), n.__H = e, n.__h = t), n.__;
}
function z(t, e) {
  return le = 8, ee(function() {
    return t;
  }, e);
}
function $n() {
  for (var t; t = $t.shift(); ) if (t.__P && t.__H) try {
    t.__H.__h.forEach(ye), t.__H.__h.forEach(Ue), t.__H.__h = [];
  } catch (e) {
    t.__H.__h = [], L.__e(e, t.__v);
  }
}
L.__b = function(t) {
  I = null, ct && ct(t);
}, L.__ = function(t, e) {
  t && e.__k && e.__k.__m && (t.__m = e.__k.__m), ht && ht(t, e);
}, L.__r = function(t) {
  lt && lt(t), ne = 0;
  var e = (I = t.__c).__H;
  e && (Fe === I ? (e.__h = [], I.__h = [], e.__.forEach(function(n) {
    n.__N && (n.__ = n.__N), n.i = n.__N = void 0;
  })) : (e.__h.forEach(ye), e.__h.forEach(Ue), e.__h = [], ne = 0)), Fe = I;
}, L.diffed = function(t) {
  ut && ut(t);
  var e = t.__c;
  e && e.__H && (e.__H.__h.length && ($t.push(e) !== 1 && at === L.requestAnimationFrame || ((at = L.requestAnimationFrame) || Hn)($n)), e.__H.__.forEach(function(n) {
    n.i && (n.__H = n.i), n.i = void 0;
  })), Fe = I = null;
}, L.__c = function(t, e) {
  e.some(function(n) {
    try {
      n.__h.forEach(ye), n.__h = n.__h.filter(function(o) {
        return !o.__ || Ue(o);
      });
    } catch (o) {
      e.some(function(r) {
        r.__h && (r.__h = []);
      }), e = [], L.__e(o, n.__v);
    }
  }), dt && dt(t, e);
}, L.unmount = function(t) {
  ft && ft(t);
  var e, n = t.__c;
  n && n.__H && (n.__H.__.forEach(function(o) {
    try {
      ye(o);
    } catch (r) {
      e = r;
    }
  }), n.__H = void 0, e && L.__e(e, n.__v));
};
var pt = typeof requestAnimationFrame == "function";
function Hn(t) {
  var e, n = function() {
    clearTimeout(o), pt && cancelAnimationFrame(e), setTimeout(t);
  }, o = setTimeout(n, 100);
  pt && (e = requestAnimationFrame(n));
}
function ye(t) {
  var e = I, n = t.__c;
  typeof n == "function" && (t.__c = void 0, n()), I = e;
}
function Ue(t) {
  var e = I;
  t.__c = t.__(), I = e;
}
function Ke(t, e) {
  return !t || t.length !== e.length || e.some(function(n, o) {
    return n !== t[o];
  });
}
function Ht(t, e) {
  return typeof e == "function" ? e(t) : e;
}
const De = {
  DefaultQuestionLabel: "How satisfied are you with this feature?",
  QuestionPlaceholder: "Write a comment",
  ScoreStatusDescription: "Pick a score and leave a comment",
  ScoreStatusLoading: "Saving score, please wait...",
  ScoreStatusReceived: "Score has been received!",
  ScoreVeryDissatisfiedLabel: "Very dissatisfied (1/5)",
  ScoreDissatisfiedLabel: "Dissatisfied (2/5)",
  ScoreNeutralLabel: "Neutral (3/5)",
  ScoreSatisfiedLabel: "Satisfied (4/5)",
  ScoreVerySatisfiedLabel: "Very satisfied (5/5)",
  SuccessMessage: "Feedback received, thank you!",
  SendButton: "Send feedback"
}, zn = ({
  initialDuration: t,
  enabled: e,
  onEnd: n
}) => {
  const [o, r] = M(!e), [i, s] = M(t), [c, u] = M(Date.now()), [l, f] = M(Date.now());
  Ee(() => {
    if (o) return;
    const _ = setInterval(() => {
      f(Date.now()), Date.now() >= c + i && (clearTimeout(_), r(!0), n());
    }, 25);
    return () => {
      clearTimeout(_);
    };
  }, [o]);
  const a = z(() => {
    r(!0);
  }, []), p = z((_) => {
    u(Date.now()), s(_), r(!1);
  }, []), d = c + i, y = (o ? 0 : l - c) / i;
  return {
    duration: i,
    elapsedFraction: y,
    startTime: c,
    endTime: d,
    stopped: o,
    startWithDuration: p,
    stop: a
  };
}, Un = (t) => /* @__PURE__ */ h(
  "svg",
  {
    width: "22",
    height: "22",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ h(
    "path",
    {
      d: "M12.0007 10.5865L16.9504 5.63672L18.3646 7.05093L13.4149 12.0007L18.3646 16.9504L16.9504 18.3646L12.0007 13.4149L7.05093 18.3646L5.63672 16.9504L10.5865 12.0007L5.63672 7.05093L7.05093 5.63672L12.0007 10.5865Z",
      fill: "currentColor"
    }
  )
), oe = Math.min, Q = Math.max, we = Math.round, ge = Math.floor, K = (t) => ({
  x: t,
  y: t
});
function Be(t, e, n) {
  return Q(t, oe(e, n));
}
function Re(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Ie(t) {
  return t.split("-")[0];
}
function Ye(t) {
  return t.split("-")[1];
}
function zt(t) {
  return t === "x" ? "y" : "x";
}
function Ut(t) {
  return t === "y" ? "height" : "width";
}
function Le(t) {
  return ["top", "bottom"].includes(Ie(t)) ? "y" : "x";
}
function Bt(t) {
  return zt(Le(t));
}
function Bn(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function Vt(t) {
  return typeof t != "number" ? Bn(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function xe(t) {
  const {
    x: e,
    y: n,
    width: o,
    height: r
  } = t;
  return {
    width: o,
    height: r,
    top: n,
    left: e,
    right: e + o,
    bottom: n + r,
    x: e,
    y: n
  };
}
function gt(t, e, n) {
  let {
    reference: o,
    floating: r
  } = t;
  const i = Le(e), s = Bt(e), c = Ut(s), u = Ie(e), l = i === "y", f = o.x + o.width / 2 - r.width / 2, a = o.y + o.height / 2 - r.height / 2, p = o[c] / 2 - r[c] / 2;
  let d;
  switch (u) {
    case "top":
      d = {
        x: f,
        y: o.y - r.height
      };
      break;
    case "bottom":
      d = {
        x: f,
        y: o.y + o.height
      };
      break;
    case "right":
      d = {
        x: o.x + o.width,
        y: a
      };
      break;
    case "left":
      d = {
        x: o.x - r.width,
        y: a
      };
      break;
    default:
      d = {
        x: o.x,
        y: o.y
      };
  }
  switch (Ye(e)) {
    case "start":
      d[s] -= p * (n && l ? -1 : 1);
      break;
    case "end":
      d[s] += p * (n && l ? -1 : 1);
      break;
  }
  return d;
}
const Vn = async (t, e, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: i = [],
    platform: s
  } = n, c = i.filter(Boolean), u = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let l = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: r
  }), {
    x: f,
    y: a
  } = gt(l, o, u), p = o, d = {}, m = 0;
  for (let y = 0; y < c.length; y++) {
    const {
      name: _,
      fn: g
    } = c[y], {
      x: b,
      y: v,
      data: w,
      reset: x
    } = await g({
      x: f,
      y: a,
      initialPlacement: o,
      placement: p,
      strategy: r,
      middlewareData: d,
      rects: l,
      platform: s,
      elements: {
        reference: t,
        floating: e
      }
    });
    f = b ?? f, a = v ?? a, d = {
      ...d,
      [_]: {
        ...d[_],
        ...w
      }
    }, x && m <= 50 && (m++, typeof x == "object" && (x.placement && (p = x.placement), x.rects && (l = x.rects === !0 ? await s.getElementRects({
      reference: t,
      floating: e,
      strategy: r
    }) : x.rects), {
      x: f,
      y: a
    } = gt(l, p, u)), y = -1);
  }
  return {
    x: f,
    y: a,
    placement: p,
    strategy: r,
    middlewareData: d
  };
};
async function Wn(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: o,
    y: r,
    platform: i,
    rects: s,
    elements: c,
    strategy: u
  } = t, {
    boundary: l = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: a = "floating",
    altBoundary: p = !1,
    padding: d = 0
  } = Re(e, t), m = Vt(d), _ = c[p ? a === "floating" ? "reference" : "floating" : a], g = xe(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(_))) == null || n ? _ : _.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(c.floating)),
    boundary: l,
    rootBoundary: f,
    strategy: u
  })), b = a === "floating" ? {
    x: o,
    y: r,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, v = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c.floating)), w = await (i.isElement == null ? void 0 : i.isElement(v)) ? await (i.getScale == null ? void 0 : i.getScale(v)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = xe(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: b,
    offsetParent: v,
    strategy: u
  }) : b);
  return {
    top: (g.top - x.top + m.top) / w.y,
    bottom: (x.bottom - g.bottom + m.bottom) / w.y,
    left: (g.left - x.left + m.left) / w.x,
    right: (x.right - g.right + m.right) / w.x
  };
}
const qn = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: i,
      platform: s,
      elements: c,
      middlewareData: u
    } = e, {
      element: l,
      padding: f = 0
    } = Re(t, e) || {};
    if (l == null)
      return {};
    const a = Vt(f), p = {
      x: n,
      y: o
    }, d = Bt(r), m = Ut(d), y = await s.getDimensions(l), _ = d === "y", g = _ ? "top" : "left", b = _ ? "bottom" : "right", v = _ ? "clientHeight" : "clientWidth", w = i.reference[m] + i.reference[d] - p[d] - i.floating[m], x = p[d] - i.reference[d], C = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(l));
    let A = C ? C[v] : 0;
    (!A || !await (s.isElement == null ? void 0 : s.isElement(C))) && (A = c.floating[v] || i.floating[m]);
    const T = w / 2 - x / 2, D = A / 2 - y[m] / 2 - 1, S = oe(a[g], D), O = oe(a[b], D), P = S, j = A - y[m] - O, F = A / 2 - y[m] / 2 + T, R = Be(P, F, j), k = !u.arrow && Ye(r) != null && F !== R && i.reference[m] / 2 - (F < P ? S : O) - y[m] / 2 < 0, U = k ? F < P ? F - P : F - j : 0;
    return {
      [d]: p[d] + U,
      data: {
        [d]: R,
        centerOffset: F - R - U,
        ...k && {
          alignmentOffset: U
        }
      },
      reset: k
    };
  }
});
async function jn(t, e) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = t, i = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), s = Ie(n), c = Ye(n), u = Le(n) === "y", l = ["left", "top"].includes(s) ? -1 : 1, f = i && u ? -1 : 1, a = Re(e, t);
  let {
    mainAxis: p,
    crossAxis: d,
    alignmentAxis: m
  } = typeof a == "number" ? {
    mainAxis: a,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...a
  };
  return c && typeof m == "number" && (d = c === "end" ? m * -1 : m), u ? {
    x: d * f,
    y: p * l
  } : {
    x: p * l,
    y: d * f
  };
}
const Zn = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, o;
      const {
        x: r,
        y: i,
        placement: s,
        middlewareData: c
      } = e, u = await jn(e, t);
      return s === ((n = c.offset) == null ? void 0 : n.placement) && (o = c.arrow) != null && o.alignmentOffset ? {} : {
        x: r + u.x,
        y: i + u.y,
        data: {
          ...u,
          placement: s
        }
      };
    }
  };
}, Kn = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: o,
        placement: r
      } = e, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: c = {
          fn: (_) => {
            let {
              x: g,
              y: b
            } = _;
            return {
              x: g,
              y: b
            };
          }
        },
        ...u
      } = Re(t, e), l = {
        x: n,
        y: o
      }, f = await Wn(e, u), a = Le(Ie(r)), p = zt(a);
      let d = l[p], m = l[a];
      if (i) {
        const _ = p === "y" ? "top" : "left", g = p === "y" ? "bottom" : "right", b = d + f[_], v = d - f[g];
        d = Be(b, d, v);
      }
      if (s) {
        const _ = a === "y" ? "top" : "left", g = a === "y" ? "bottom" : "right", b = m + f[_], v = m - f[g];
        m = Be(b, m, v);
      }
      const y = c.fn({
        ...e,
        [p]: d,
        [a]: m
      });
      return {
        ...y,
        data: {
          x: y.x - n,
          y: y.y - o
        }
      };
    }
  };
};
function se(t) {
  return Wt(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function $(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function q(t) {
  var e;
  return (e = (Wt(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function Wt(t) {
  return t instanceof Node || t instanceof $(t).Node;
}
function B(t) {
  return t instanceof Element || t instanceof $(t).Element;
}
function W(t) {
  return t instanceof HTMLElement || t instanceof $(t).HTMLElement;
}
function _t(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof $(t).ShadowRoot;
}
function fe(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: o,
    display: r
  } = V(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + o + n) && !["inline", "contents"].includes(r);
}
function Yn(t) {
  return ["table", "td", "th"].includes(se(t));
}
function Ae(t) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
function Je(t) {
  const e = Qe(), n = B(t) ? V(t) : t;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((o) => (n.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (n.contain || "").includes(o));
}
function Jn(t) {
  let e = Y(t);
  for (; W(e) && !re(e); ) {
    if (Je(e))
      return e;
    if (Ae(e))
      return null;
    e = Y(e);
  }
  return null;
}
function Qe() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function re(t) {
  return ["html", "body", "#document"].includes(se(t));
}
function V(t) {
  return $(t).getComputedStyle(t);
}
function Te(t) {
  return B(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function Y(t) {
  if (se(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    _t(t) && t.host || // Fallback.
    q(t)
  );
  return _t(e) ? e.host : e;
}
function qt(t) {
  const e = Y(t);
  return re(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : W(e) && fe(e) ? e : qt(e);
}
function ue(t, e, n) {
  var o;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const r = qt(t), i = r === ((o = t.ownerDocument) == null ? void 0 : o.body), s = $(r);
  return i ? e.concat(s, s.visualViewport || [], fe(r) ? r : [], s.frameElement && n ? ue(s.frameElement) : []) : e.concat(r, ue(r, [], n));
}
function jt(t) {
  const e = V(t);
  let n = parseFloat(e.width) || 0, o = parseFloat(e.height) || 0;
  const r = W(t), i = r ? t.offsetWidth : n, s = r ? t.offsetHeight : o, c = we(n) !== i || we(o) !== s;
  return c && (n = i, o = s), {
    width: n,
    height: o,
    $: c
  };
}
function Xe(t) {
  return B(t) ? t : t.contextElement;
}
function te(t) {
  const e = Xe(t);
  if (!W(e))
    return K(1);
  const n = e.getBoundingClientRect(), {
    width: o,
    height: r,
    $: i
  } = jt(e);
  let s = (i ? we(n.width) : n.width) / o, c = (i ? we(n.height) : n.height) / r;
  return (!s || !Number.isFinite(s)) && (s = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: s,
    y: c
  };
}
const Qn = /* @__PURE__ */ K(0);
function Zt(t) {
  const e = $(t);
  return !Qe() || !e.visualViewport ? Qn : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function Xn(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== $(t) ? !1 : e;
}
function G(t, e, n, o) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const r = t.getBoundingClientRect(), i = Xe(t);
  let s = K(1);
  e && (o ? B(o) && (s = te(o)) : s = te(t));
  const c = Xn(i, n, o) ? Zt(i) : K(0);
  let u = (r.left + c.x) / s.x, l = (r.top + c.y) / s.y, f = r.width / s.x, a = r.height / s.y;
  if (i) {
    const p = $(i), d = o && B(o) ? $(o) : o;
    let m = p, y = m.frameElement;
    for (; y && o && d !== m; ) {
      const _ = te(y), g = y.getBoundingClientRect(), b = V(y), v = g.left + (y.clientLeft + parseFloat(b.paddingLeft)) * _.x, w = g.top + (y.clientTop + parseFloat(b.paddingTop)) * _.y;
      u *= _.x, l *= _.y, f *= _.x, a *= _.y, u += v, l += w, m = $(y), y = m.frameElement;
    }
  }
  return xe({
    width: f,
    height: a,
    x: u,
    y: l
  });
}
function Gn(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: o,
    strategy: r
  } = t;
  const i = r === "fixed", s = q(o), c = e ? Ae(e.floating) : !1;
  if (o === s || c && i)
    return n;
  let u = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = K(1);
  const f = K(0), a = W(o);
  if ((a || !a && !i) && ((se(o) !== "body" || fe(s)) && (u = Te(o)), W(o))) {
    const p = G(o);
    l = te(o), f.x = p.x + o.clientLeft, f.y = p.y + o.clientTop;
  }
  return {
    width: n.width * l.x,
    height: n.height * l.y,
    x: n.x * l.x - u.scrollLeft * l.x + f.x,
    y: n.y * l.y - u.scrollTop * l.y + f.y
  };
}
function eo(t) {
  return Array.from(t.getClientRects());
}
function Kt(t) {
  return G(q(t)).left + Te(t).scrollLeft;
}
function to(t) {
  const e = q(t), n = Te(t), o = t.ownerDocument.body, r = Q(e.scrollWidth, e.clientWidth, o.scrollWidth, o.clientWidth), i = Q(e.scrollHeight, e.clientHeight, o.scrollHeight, o.clientHeight);
  let s = -n.scrollLeft + Kt(t);
  const c = -n.scrollTop;
  return V(o).direction === "rtl" && (s += Q(e.clientWidth, o.clientWidth) - r), {
    width: r,
    height: i,
    x: s,
    y: c
  };
}
function no(t, e) {
  const n = $(t), o = q(t), r = n.visualViewport;
  let i = o.clientWidth, s = o.clientHeight, c = 0, u = 0;
  if (r) {
    i = r.width, s = r.height;
    const l = Qe();
    (!l || l && e === "fixed") && (c = r.offsetLeft, u = r.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: c,
    y: u
  };
}
function oo(t, e) {
  const n = G(t, !0, e === "fixed"), o = n.top + t.clientTop, r = n.left + t.clientLeft, i = W(t) ? te(t) : K(1), s = t.clientWidth * i.x, c = t.clientHeight * i.y, u = r * i.x, l = o * i.y;
  return {
    width: s,
    height: c,
    x: u,
    y: l
  };
}
function mt(t, e, n) {
  let o;
  if (e === "viewport")
    o = no(t, n);
  else if (e === "document")
    o = to(q(t));
  else if (B(e))
    o = oo(e, n);
  else {
    const r = Zt(t);
    o = {
      ...e,
      x: e.x - r.x,
      y: e.y - r.y
    };
  }
  return xe(o);
}
function Yt(t, e) {
  const n = Y(t);
  return n === e || !B(n) || re(n) ? !1 : V(n).position === "fixed" || Yt(n, e);
}
function ro(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let o = ue(t, [], !1).filter((c) => B(c) && se(c) !== "body"), r = null;
  const i = V(t).position === "fixed";
  let s = i ? Y(t) : t;
  for (; B(s) && !re(s); ) {
    const c = V(s), u = Je(s);
    !u && c.position === "fixed" && (r = null), (i ? !u && !r : !u && c.position === "static" && !!r && ["absolute", "fixed"].includes(r.position) || fe(s) && !u && Yt(t, s)) ? o = o.filter((f) => f !== s) : r = c, s = Y(s);
  }
  return e.set(t, o), o;
}
function io(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = t;
  const s = [...n === "clippingAncestors" ? Ae(e) ? [] : ro(e, this._c) : [].concat(n), o], c = s[0], u = s.reduce((l, f) => {
    const a = mt(e, f, r);
    return l.top = Q(a.top, l.top), l.right = oe(a.right, l.right), l.bottom = oe(a.bottom, l.bottom), l.left = Q(a.left, l.left), l;
  }, mt(e, c, r));
  return {
    width: u.right - u.left,
    height: u.bottom - u.top,
    x: u.left,
    y: u.top
  };
}
function so(t) {
  const {
    width: e,
    height: n
  } = jt(t);
  return {
    width: e,
    height: n
  };
}
function ao(t, e, n) {
  const o = W(e), r = q(e), i = n === "fixed", s = G(t, !0, i, e);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const u = K(0);
  if (o || !o && !i)
    if ((se(e) !== "body" || fe(r)) && (c = Te(e)), o) {
      const a = G(e, !0, i, e);
      u.x = a.x + e.clientLeft, u.y = a.y + e.clientTop;
    } else r && (u.x = Kt(r));
  const l = s.left + c.scrollLeft - u.x, f = s.top + c.scrollTop - u.y;
  return {
    x: l,
    y: f,
    width: s.width,
    height: s.height
  };
}
function Me(t) {
  return V(t).position === "static";
}
function bt(t, e) {
  return !W(t) || V(t).position === "fixed" ? null : e ? e(t) : t.offsetParent;
}
function Jt(t, e) {
  const n = $(t);
  if (Ae(t))
    return n;
  if (!W(t)) {
    let r = Y(t);
    for (; r && !re(r); ) {
      if (B(r) && !Me(r))
        return r;
      r = Y(r);
    }
    return n;
  }
  let o = bt(t, e);
  for (; o && Yn(o) && Me(o); )
    o = bt(o, e);
  return o && re(o) && Me(o) && !Je(o) ? n : o || Jn(t) || n;
}
const co = async function(t) {
  const e = this.getOffsetParent || Jt, n = this.getDimensions, o = await n(t.floating);
  return {
    reference: ao(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function lo(t) {
  return V(t).direction === "rtl";
}
const uo = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Gn,
  getDocumentElement: q,
  getClippingRect: io,
  getOffsetParent: Jt,
  getElementRects: co,
  getClientRects: eo,
  getDimensions: so,
  getScale: te,
  isElement: B,
  isRTL: lo
};
function fo(t, e) {
  let n = null, o;
  const r = q(t);
  function i() {
    var c;
    clearTimeout(o), (c = n) == null || c.disconnect(), n = null;
  }
  function s(c, u) {
    c === void 0 && (c = !1), u === void 0 && (u = 1), i();
    const {
      left: l,
      top: f,
      width: a,
      height: p
    } = t.getBoundingClientRect();
    if (c || e(), !a || !p)
      return;
    const d = ge(f), m = ge(r.clientWidth - (l + a)), y = ge(r.clientHeight - (f + p)), _ = ge(l), b = {
      rootMargin: -d + "px " + -m + "px " + -y + "px " + -_ + "px",
      threshold: Q(0, oe(1, u)) || 1
    };
    let v = !0;
    function w(x) {
      const C = x[0].intersectionRatio;
      if (C !== u) {
        if (!v)
          return s();
        C ? s(!1, C) : o = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      v = !1;
    }
    try {
      n = new IntersectionObserver(w, {
        ...b,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(w, b);
    }
    n.observe(t);
  }
  return s(!0), i;
}
function ho(t, e, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: u = !1
  } = o, l = Xe(t), f = r || i ? [...l ? ue(l) : [], ...ue(e)] : [];
  f.forEach((g) => {
    r && g.addEventListener("scroll", n, {
      passive: !0
    }), i && g.addEventListener("resize", n);
  });
  const a = l && c ? fo(l, n) : null;
  let p = -1, d = null;
  s && (d = new ResizeObserver((g) => {
    let [b] = g;
    b && b.target === l && d && (d.unobserve(e), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var v;
      (v = d) == null || v.observe(e);
    })), n();
  }), l && !u && d.observe(l), d.observe(e));
  let m, y = u ? G(t) : null;
  u && _();
  function _() {
    const g = G(t);
    y && (g.x !== y.x || g.y !== y.y || g.width !== y.width || g.height !== y.height) && n(), y = g, m = requestAnimationFrame(_);
  }
  return n(), () => {
    var g;
    f.forEach((b) => {
      r && b.removeEventListener("scroll", n), i && b.removeEventListener("resize", n);
    }), a == null || a(), (g = d) == null || g.disconnect(), d = null, u && cancelAnimationFrame(m);
  };
}
const Qt = Zn, po = Kn, yt = qn, go = (t, e, n) => {
  const o = /* @__PURE__ */ new Map(), r = {
    platform: uo,
    ...n
  }, i = {
    ...r.platform,
    _c: o
  };
  return Vn(t, e, {
    ...r,
    platform: i
  });
}, Xt = (t) => {
  function e(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: t,
    fn(n) {
      const { element: o, padding: r } = typeof t == "function" ? t(n) : t;
      return o && e(o) ? o.current != null ? yt({ element: o.current, padding: r }).fn(n) : {} : o ? yt({ element: o, padding: r }).fn(n) : {};
    }
  };
};
function ke(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let n, o, r;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n != e.length) return !1;
      for (o = n; o-- !== 0; )
        if (!ke(t[o], e[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(t), n = r.length, n !== Object.keys(e).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(e, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const i = r[o];
      if (!(i === "_owner" && t.$$typeof) && !ke(t[i], e[i]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function Gt(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function vt(t, e) {
  const n = Gt(t);
  return Math.round(e * n) / n;
}
function wt(t) {
  const e = H(t);
  return be(() => {
    e.current = t;
  }), e;
}
function en(t = {}) {
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: { reference: i, floating: s } = {},
    transform: c = !0,
    whileElementsMounted: u,
    open: l
  } = t, [f, a] = M({
    x: 0,
    y: 0,
    strategy: n,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [p, d] = M(o);
  ke(p, o) || d(o);
  const [m, y] = M(null), [_, g] = M(null), b = z(
    (k) => {
      k != C.current && (C.current = k, y(k));
    },
    [y]
  ), v = z(
    (k) => {
      k !== A.current && (A.current = k, g(k));
    },
    [g]
  ), w = i || m, x = s || _, C = H(null), A = H(null), T = H(f), D = wt(u), S = wt(r), O = z(() => {
    if (!C.current || !A.current)
      return;
    const k = {
      placement: e,
      strategy: n,
      middleware: p
    };
    S.current && (k.platform = S.current), go(C.current, A.current, k).then(
      (U) => {
        const N = { ...U, isPositioned: !0 };
        P.current && !ke(T.current, N) && (T.current = N, a(N));
      }
    );
  }, [p, e, n, S]);
  be(() => {
    l === !1 && T.current.isPositioned && (T.current.isPositioned = !1, a((k) => ({ ...k, isPositioned: !1 })));
  }, [l]);
  const P = H(!1);
  be(() => (P.current = !0, () => {
    P.current = !1;
  }), []), be(() => {
    if (w && (C.current = w), x && (A.current = x), w && x)
      return D.current ? D.current(w, x, O) : O();
  }, [w, x, O, D]);
  const j = ee(
    () => ({
      reference: C,
      floating: A,
      setReference: b,
      setFloating: v
    }),
    [b, v]
  ), F = ee(
    () => ({ reference: w, floating: x }),
    [w, x]
  ), R = ee(() => {
    const k = {
      position: n,
      left: 0,
      top: 0
    };
    if (!F.floating)
      return k;
    const U = vt(F.floating, f.x), N = vt(F.floating, f.y);
    return c ? {
      ...k,
      transform: `translate(${U}px, ${N}px)`,
      ...Gt(F.floating) >= 1.5 && { willChange: "transform" }
    } : {
      position: n,
      left: U,
      top: N
    };
  }, [n, c, F.floating, f.x, f.y]);
  return ee(
    () => ({
      ...f,
      update: O,
      refs: j,
      elements: F,
      floatingStyles: R
    }),
    [f, O, j, F, R]
  );
}
const _o = (t) => /* @__PURE__ */ h(
  "svg",
  {
    height: "24px",
    width: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ h(
    "path",
    {
      fill: "currentColor",
      d: "m10 15.17l9.193-9.191l1.414 1.414l-10.606 10.606l-6.364-6.364l1.414-1.414l4.95 4.95Z"
    }
  )
), mo = (t) => /* @__PURE__ */ h(
  "svg",
  {
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ h(
    "path",
    {
      fill: "currentColor",
      d: "M12 24C5.3724 24 0 18.6276 0 12C0 5.3724 5.3724 0 12 0C18.6276 0 24 5.3724 24 12C24 18.6276 18.6276 24 12 24ZM10.8036 16.8L19.2876 8.3148L17.5908 6.618L10.8036 13.4064L7.4088 10.0116L5.712 11.7084L10.8036 16.8Z"
    }
  )
), bo = ({
  variant: t = "primary",
  children: e,
  ...n
}) => {
  const o = ["button", t].join(" ");
  return /* @__PURE__ */ h("button", { class: o, ...n }, e);
}, yo = (t) => /* @__PURE__ */ h(
  "svg",
  {
    width: "10px",
    height: "10px",
    viewBox: "0 0 300 316",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ h(
    "path",
    {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M149.608 33.1691C114.541 33.1691 88.1957 34.0727 68.6978 35.2674C45.9877 36.6589 31.2447 53.6165 32.7413 77.1477C33.9788 96.6049 36.0938 122.855 39.6451 157.89C44.0755 201.599 48.0467 231.615 51.1923 251.815C53.8983 269.193 66.5685 280.724 83.8252 281.651C99.4409 282.49 120.822 283.137 149.608 283.137C178.991 283.137 200.659 282.463 216.355 281.599C232.793 280.694 244.886 269.593 247.467 252.738C249.007 242.679 250.794 230.104 252.816 214.471C254.076 204.729 255.427 193.799 256.866 181.551C257.741 174.108 258.648 166.178 259.588 157.731C263.785 119.994 266.075 92.6244 267.274 72.9772C268.564 51.838 255.492 36.9197 234.632 35.5304C214.779 34.208 187.208 33.1691 149.608 33.1691ZM66.7035 2.65939C86.9741 1.41736 113.994 0.5 149.608 0.5C187.792 0.5 216.098 1.55452 236.8 2.93336C275.829 5.53288 302.222 36.1432 299.852 74.9692C298.613 95.2768 296.268 123.202 292.026 161.346C287.025 206.312 282.898 236.995 279.729 257.688C274.896 289.249 250.57 312.434 218.147 314.218C201.752 315.121 179.476 315.806 149.608 315.806C120.346 315.806 98.3726 315.149 82.0761 314.273C49.1273 312.503 23.9794 289.192 18.9427 256.846C15.6873 235.941 11.6471 205.329 7.17277 161.187C3.58873 125.829 1.43655 99.164 0.168272 79.2232C-2.42412 38.4637 25.1723 5.20409 66.7035 2.65939Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ h(
    "path",
    {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M150.869 165.962C150.29 165.209 149.718 164.45 149.156 163.684C144.318 157.097 140.113 150.016 136.63 142.531C132.143 132.889 136.224 124.122 143.367 120.398C151.531 116.142 162.346 120.398 166.226 128.738C169.442 135.653 173.494 142.1 178.25 147.949C193.08 166.186 214.765 178.615 239.375 181.302C242.678 181.662 246.035 181.848 249.434 181.848C251.936 181.848 254.415 181.747 256.866 181.551C260.357 181.848 256.071 214.471 252.816 214.471C251.692 214.501 250.565 214.517 249.434 214.517C245.891 214.517 242.383 214.368 238.915 214.078C203.102 211.075 171.603 192.885 150.869 165.962Z",
      fill: "currentColor"
    }
  )
), xt = () => /* @__PURE__ */ h("footer", { class: "plug" }, /* @__PURE__ */ h("a", { href: "https://bucket.co", target: "_blank" }, "Powered by ", /* @__PURE__ */ h(yo, null), " Bucket")), vo = (t) => /* @__PURE__ */ h(
  "svg",
  {
    width: "22",
    height: "22",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ h(
    "path",
    {
      d: "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ h(
    "path",
    {
      d: "M12 15C13.1835 15 14.2712 15.4113 15.1279 16.0991C15.4665 16.3709 15.4398 16.8738 15.1187 17.166C14.8962 17.3685 14.5788 17.4225 14.2915 17.3332C13.605 17.1198 12.8259 17 12 17C11.1741 17 10.3949 17.1205 9.70841 17.3331C9.42116 17.422 9.104 17.3677 8.88161 17.1653C8.56025 16.8728 8.53318 16.3695 8.87206 16.0976C9.2087 15.8274 9.57986 15.6014 9.97666 15.426C10.6139 15.1442 11.3032 14.9991 12 15ZM8.5 10C8.89783 10 9.27936 10.158 9.56066 10.4393C9.84197 10.7206 10 11.1022 10 11.5C10 11.8978 9.84197 12.2794 9.56066 12.5607C9.27936 12.842 8.89783 13 8.5 13C8.10218 13 7.72065 12.842 7.43934 12.5607C7.15804 12.2794 7 11.8978 7 11.5C7 11.1022 7.15804 10.7206 7.43934 10.4393C7.72065 10.158 8.10218 10 8.5 10ZM15.5 10C15.8978 10 16.2794 10.158 16.5607 10.4393C16.842 10.7206 17 11.1022 17 11.5C17 11.8978 16.842 12.2794 16.5607 12.5607C16.2794 12.842 15.8978 13 15.5 13C15.1022 13 14.7206 12.842 14.4393 12.5607C14.158 12.2794 14 11.8978 14 11.5C14 11.1022 14.158 10.7206 14.4393 10.4393C14.7206 10.158 15.1022 10 15.5 10Z",
      fill: "currentColor"
    }
  )
), wo = (t) => /* @__PURE__ */ h(
  "svg",
  {
    width: "22",
    height: "22",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ h(
    "path",
    {
      d: "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM8 15C8 14.4477 8.44771 14 9 14H15C15.5523 14 16 14.4477 16 15V15C16 15.5523 15.5523 16 15 16H9C8.44771 16 8 15.5523 8 15V15ZM8 11C7.60217 11 7.22064 10.842 6.93934 10.5607C6.65803 10.2794 6.5 9.89782 6.5 9.5C6.5 9.10217 6.65803 8.72064 6.93934 8.43934C7.22064 8.15803 7.60217 8 8 8C8.39782 8 8.77935 8.15803 9.06066 8.43934C9.34196 8.72064 9.5 9.10217 9.5 9.5C9.5 9.89782 9.34196 10.2794 9.06066 10.5607C8.77935 10.842 8.39782 11 8 11ZM16 11C15.6022 11 15.2206 10.842 14.9393 10.5607C14.658 10.2794 14.5 9.89782 14.5 9.5C14.5 9.10217 14.658 8.72064 14.9393 8.43934C15.2206 8.15803 15.6022 8 16 8C16.3978 8 16.7794 8.15803 17.0607 8.43934C17.342 8.72064 17.5 9.10217 17.5 9.5C17.5 9.89782 17.342 10.2794 17.0607 10.5607C16.7794 10.842 16.3978 11 16 11Z",
      fill: "currentColor"
    }
  )
), xo = (t) => /* @__PURE__ */ h(
  "svg",
  {
    width: "22",
    height: "22",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ h(
    "path",
    {
      d: "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM8 11C7.60217 11 7.22064 10.842 6.93934 10.5607C6.65803 10.2794 6.5 9.89782 6.5 9.5C6.5 9.10217 6.65803 8.72064 6.93934 8.43934C7.22064 8.15803 7.60217 8 8 8C8.39782 8 8.77935 8.15803 9.06066 8.43934C9.34196 8.72064 9.5 9.10217 9.5 9.5C9.5 9.89782 9.34196 10.2794 9.06066 10.5607C8.77935 10.842 8.39782 11 8 11ZM16 11C15.6022 11 15.2206 10.842 14.9393 10.5607C14.658 10.2794 14.5 9.89782 14.5 9.5C14.5 9.10217 14.658 8.72064 14.9393 8.43934C15.2206 8.15803 15.6022 8 16 8C16.3978 8 16.7794 8.15803 17.0607 8.43934C17.342 8.72064 17.5 9.10217 17.5 9.5C17.5 9.89782 17.342 10.2794 17.0607 10.5607C16.7794 10.842 16.3978 11 16 11Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ h(
    "path",
    {
      d: "M7.79862 15.4322C8.85269 16.5065 10.4964 17.4971 11.9993 17.4971C13.5011 17.4971 15.1701 16.5079 16.2097 15.4351C16.5083 15.1269 16.4581 14.6416 16.1408 14.3528C15.9042 14.1375 15.5656 14.0777 15.2972 14.2517C14.5161 14.7578 13.4271 15.7002 11.9993 15.7002C10.5688 15.7002 9.47831 14.7549 8.69694 14.2486C8.43116 14.0764 8.09564 14.1353 7.86141 14.3485C7.5435 14.6378 7.49757 15.1254 7.79862 15.4322Z",
      fill: "currentColor"
    }
  )
), ko = (t) => /* @__PURE__ */ h(
  "svg",
  {
    width: "22",
    height: "22",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ h(
    "path",
    {
      d: "M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM8 17C7.44771 17 6.98992 16.5479 7.09965 16.0066C7.29346 15.0506 7.76447 14.1645 8.46447 13.4645C9.40215 12.5268 10.6739 12 12 12C13.3261 12 14.5979 12.5268 15.5355 13.4645C16.2355 14.1645 16.7065 15.0506 16.9003 16.0066C17.0101 16.5479 16.5523 17 16 17V17C15.4477 17 15.0156 16.5403 14.8349 16.0184C14.6877 15.5934 14.4454 15.2028 14.1213 14.8787C13.5587 14.3161 12.7956 14 12 14C11.2043 14 10.4413 14.3161 9.87868 14.8787C9.55459 15.2028 9.31232 15.5934 9.16513 16.0184C8.98442 16.5403 8.55228 17 8 17V17ZM8 11C7.60217 11 7.22064 10.842 6.93934 10.5607C6.65803 10.2794 6.5 9.89782 6.5 9.5C6.5 9.10217 6.65803 8.72064 6.93934 8.43934C7.22064 8.15803 7.60217 8 8 8C8.39782 8 8.77935 8.15803 9.06066 8.43934C9.34196 8.72064 9.5 9.10217 9.5 9.5C9.5 9.89782 9.34196 10.2794 9.06066 10.5607C8.77935 10.842 8.39782 11 8 11ZM16 11C15.6022 11 15.2206 10.842 14.9393 10.5607C14.658 10.2794 14.5 9.89782 14.5 9.5C14.5 9.10217 14.658 8.72064 14.9393 8.43934C15.2206 8.15803 15.6022 8 16 8C16.3978 8 16.7794 8.15803 17.0607 8.43934C17.342 8.72064 17.5 9.10217 17.5 9.5C17.5 9.89782 17.342 10.2794 17.0607 10.5607C16.7794 10.842 16.3978 11 16 11Z",
      fill: "currentColor"
    }
  )
), Co = (t) => /* @__PURE__ */ h(
  "svg",
  {
    width: "22",
    height: "22",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ h(
    "path",
    {
      d: "M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4ZM12 12C14 12 15.667 12.333 17 13C17 14.3261 16.4732 15.5979 15.5355 16.5355C14.5979 17.4732 13.3261 18 12 18C10.6739 18 9.40215 17.4732 8.46447 16.5355C7.52678 15.5979 7 14.3261 7 13C8.333 12.333 10 12 12 12ZM8.5 7C9.07633 6.99988 9.63499 7.19889 10.0815 7.56335C10.5279 7.9278 10.8347 8.43532 10.95 9H6.05C6.16526 8.43532 6.47209 7.9278 6.91855 7.56335C7.36501 7.19889 7.92367 6.99988 8.5 7ZM15.5 7C16.0763 6.99988 16.635 7.19889 17.0814 7.56335C17.5279 7.9278 17.8347 8.43532 17.95 9H13.05C13.1653 8.43532 13.4721 7.9278 13.9185 7.56335C14.365 7.19889 14.9237 6.99988 15.5 7Z",
      fill: "currentColor"
    }
  )
), kt = [
  {
    color: "var(--bucket-feedback-dialog-rating-1-color, #dd6b20)",
    bg: "var(--bucket-feedback-dialog-rating-1-background-color, #fbd38d)",
    icon: /* @__PURE__ */ h(ko, null),
    getLabel: (t) => t.ScoreVeryDissatisfiedLabel,
    value: 1
  },
  {
    color: "var(--bucket-feedback-dialog-rating-2-color, #ed8936)",
    bg: "var(--bucket-feedback-dialog-rating-2-background-color, #feebc8)",
    icon: /* @__PURE__ */ h(vo, null),
    getLabel: (t) => t.ScoreDissatisfiedLabel,
    value: 2
  },
  {
    color: "var(--bucket-feedback-dialog-rating-3-color, #787c91)",
    bg: "var(--bucket-feedback-dialog-rating-3-background-color, #e9e9ed)",
    icon: /* @__PURE__ */ h(wo, null),
    getLabel: (t) => t.ScoreNeutralLabel,
    value: 3
  },
  {
    color: "var(--bucket-feedback-dialog-rating-4-color, #48bb78)",
    bg: "var(--bucket-feedback-dialog-rating-4-background-color, #c6f6d5)",
    icon: /* @__PURE__ */ h(xo, null),
    getLabel: (t) => t.ScoreSatisfiedLabel,
    value: 4
  },
  {
    color: "var(--bucket-feedback-dialog-rating-5-color, #38a169)",
    bg: "var(--bucket-feedback-dialog-rating-5-background-color, #9ae6b4)",
    icon: /* @__PURE__ */ h(Co, null),
    getLabel: (t) => t.ScoreVerySatisfiedLabel,
    value: 5
  }
], So = ({
  t,
  name: e,
  selectedValue: n,
  onChange: o
}) => /* @__PURE__ */ h("div", { class: "star-rating" }, /* @__PURE__ */ h("style", null, kt.map(
  ({ bg: r, color: i }, s) => `
            .star-rating-icons > input:nth-of-type(${s + 1}):checked + .button {
              border-color: ${i};
            }

            .star-rating-icons > input:nth-of-type(${s + 1}):checked + .button > div {
              background-color: ${r};
            }

            .star-rating-icons > input:nth-of-type(${s + 1}):checked ~ input:nth-of-type(${s + 2}) + .button {
              border-left-color: ${i};
            }
          `
)), /* @__PURE__ */ h("div", { class: "star-rating-icons" }, kt.map((r) => /* @__PURE__ */ h(
  Eo,
  {
    isSelected: r.value === n,
    name: e,
    onChange: o,
    score: r,
    t
  }
)))), Eo = ({
  isSelected: t,
  name: e,
  onChange: n,
  score: o,
  t: r
}) => {
  var l, f;
  const i = H(null), { refs: s, floatingStyles: c, middlewareData: u } = en({
    placement: "top",
    middleware: [
      Qt(4),
      Xt({
        element: i
      })
    ]
  });
  return /* @__PURE__ */ h(ie, null, /* @__PURE__ */ h(
    "input",
    {
      id: `bucket-feedback-score-${o.value}`,
      type: "radio",
      name: e,
      value: o.value,
      defaultChecked: t,
      onChange: n
    }
  ), /* @__PURE__ */ h(
    "label",
    {
      ref: s.setReference,
      for: `bucket-feedback-score-${o.value}`,
      class: "button",
      style: { color: o.color },
      "aria-label": o.getLabel(r)
    },
    /* @__PURE__ */ h(
      "div",
      {
        style: {
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          opacity: 0.2,
          // TODO: fix overflow
          zIndex: 1
        }
      }
    ),
    /* @__PURE__ */ h("span", { style: { zIndex: 2, display: "flex", alignItems: "center" } }, o.icon)
  ), /* @__PURE__ */ h("div", { ref: s.setFloating, class: "button-tooltip", style: c }, o.getLabel(r), /* @__PURE__ */ h(
    "div",
    {
      ref: i,
      class: "button-tooltip-arrow",
      style: {
        left: ((l = u.arrow) == null ? void 0 : l.x) != null ? `${u.arrow.x}px` : "",
        top: ((f = u.arrow) == null ? void 0 : f.y) != null ? `${u.arrow.y}px` : ""
      }
    }
  )));
}, Ro = 400;
function Io(t) {
  var n, o;
  const e = new FormData(t);
  return {
    score: Number((n = e.get("score")) == null ? void 0 : n.toString()),
    comment: (((o = e.get("comment")) == null ? void 0 : o.toString()) || "").trim()
  };
}
const Lo = ({
  question: t,
  scoreState: e,
  openWithCommentVisible: n,
  onInteraction: o,
  onSubmit: r,
  onScoreSubmit: i,
  t: s
}) => {
  const [c, u] = M(!1), [l, f] = M(
    "idle"
  ), [a, p] = M(), [d, m] = M(!0), y = async (T) => {
    T.preventDefault();
    const D = {
      ...Io(T.target),
      question: t
    };
    if (D.score) {
      p("");
      try {
        f("submitting"), await r(D), f("submitted");
      } catch (S) {
        f("idle"), S instanceof Error ? p(S.message) : p(typeof S == "string" ? S : "Couldn't submit feedback. Please try again.");
      }
    }
  }, _ = H(null), g = H(null), b = H(null), v = H(null), w = H(null), x = z(() => {
    _.current !== null && b.current !== null && v.current !== null && (_.current.style.maxHeight = b.current.clientHeight + "px", v.current.style.position = "absolute", v.current.style.opacity = "0", v.current.style.pointerEvents = "none");
  }, [_, b, v]), C = z(() => {
    _.current !== null && b.current !== null && v.current !== null && (_.current.style.maxHeight = b.current.clientHeight + // Header height
    v.current.clientHeight + // Comment + Button Height
    10 + // Gap height
    "px", v.current.style.position = "relative", v.current.style.opacity = "1", v.current.style.pointerEvents = "all");
  }, [_, b, v]), A = z(() => {
    _.current !== null && g.current !== null && w.current !== null && (g.current.style.opacity = "0", g.current.style.pointerEvents = "none", _.current.style.maxHeight = w.current.clientHeight + "px", setTimeout(() => {
      w.current.style.position = "relative", w.current.style.opacity = "1", w.current.style.pointerEvents = "all", m(!1);
    }, Ro + 10));
  }, [g, _, w]);
  return Ee(() => {
    l === "submitted" ? A() : n || c ? C() : x();
  }, [
    x,
    C,
    A,
    n,
    c,
    l
  ]), /* @__PURE__ */ h("div", { ref: _, class: "container" }, /* @__PURE__ */ h("div", { ref: w, class: "submitted" }, /* @__PURE__ */ h("div", { className: "submitted-check" }, /* @__PURE__ */ h(mo, { width: 24, height: 24 })), /* @__PURE__ */ h("p", { className: "text" }, s.SuccessMessage), /* @__PURE__ */ h(xt, null)), d && /* @__PURE__ */ h(
    "form",
    {
      ref: g,
      onSubmit: y,
      method: "dialog",
      class: "form",
      onFocus: o,
      onFocusCapture: o,
      onClick: o,
      style: { opacity: 1 }
    },
    /* @__PURE__ */ h(
      "div",
      {
        ref: b,
        role: "group",
        class: "form-control",
        "aria-labelledby": "bucket-feedback-score-label"
      },
      /* @__PURE__ */ h("div", { id: "bucket-feedback-score-label", class: "title" }, t),
      /* @__PURE__ */ h(
        So,
        {
          t: s,
          name: "score",
          onChange: async (T) => {
            u(!0), await i({
              question: t,
              score: Number(T.currentTarget.value)
            });
          }
        }
      ),
      /* @__PURE__ */ h(Ao, { t: s, scoreState: e })
    ),
    /* @__PURE__ */ h("div", { ref: v, class: "form-expanded-content" }, /* @__PURE__ */ h("div", { class: "form-control" }, /* @__PURE__ */ h(
      "textarea",
      {
        id: "bucket-feedback-comment-label",
        class: "textarea",
        name: "comment",
        placeholder: s.QuestionPlaceholder,
        rows: 4
      }
    )), a && /* @__PURE__ */ h("p", { class: "error" }, a), /* @__PURE__ */ h(
      bo,
      {
        type: "submit",
        disabled: !c || l === "submitting" || e === "submitting"
      },
      s.SendButton
    ), /* @__PURE__ */ h(xt, null))
  ));
}, Ao = ({ t, scoreState: e }) => {
  const [n, o] = M(!1), [r, i] = M(!1);
  Ee(() => {
    if (e === "idle") {
      o(!1);
      return;
    }
    if (e === "submitted") {
      o(!1), i(!0);
      return;
    }
    const l = setTimeout(() => {
      o(!0);
    }, 400);
    return () => clearTimeout(l);
  }, [e]);
  const s = e === "idle" || e === "submitting" && !r && !n, c = e !== "submitted" && !r && n, u = e === "submitted" || r;
  return /* @__PURE__ */ h("div", { className: "score-status-container" }, /* @__PURE__ */ h("span", { className: "score-status", style: { opacity: s ? 1 : 0 } }, t.ScoreStatusDescription), /* @__PURE__ */ h("div", { className: "score-status", style: { opacity: c ? 1 : 0 } }, t.ScoreStatusLoading), /* @__PURE__ */ h("span", { className: "score-status", style: { opacity: u ? 1 : 0 } }, /* @__PURE__ */ h(_o, { width: 14, height: 14, style: { marginRight: 3 } }), " ", t.ScoreStatusReceived));
}, To = ".button{-webkit-appearance:none;-moz-appearance:none;appearance:none;display:inline-flex;align-items:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;position:relative;white-space:nowrap;height:2rem;padding-left:.75rem;padding-right:.75rem;gap:.5em;justify-content:center;border:none;cursor:pointer;font-family:var(--bucket-feedback-dialog-font-family);font-size:12px;font-weight:500;box-shadow:0 1px 2px #0000000f,0 1px 1px #00000003;border-radius:6px;border-radius:var(--bucket-feedback-dialog-border-radius, 6px);transition-duration:.2s;transition-property:background-color,border-color,color,opacity,box-shadow,transform}.button.primary{background-color:#fff;background-color:var( --bucket-feedback-dialog-primary-button-background-color, white );color:#1e1f24;color:var(--bucket-feedback-dialog-primary-button-color, #1e1f24);border:1px solid #d8d9df;border:1px solid var(--bucket-feedback-dialog-primary-border-color, #d8d9df)}.button:disabled{opacity:.5;cursor:not-allowed;border-color:#d8d9df;border-color:var(--bucket-feedback-dialog-primary-border-color, #d8d9df);transition-duration:.2s;transition-property:background-color,border-color,color,opacity,box-shadow,transform}.button:focus{outline:none;border-color:#787c91;border-color:var( --bucket-feedback-dialog-input-focus-border-color, #787c91 )}@keyframes scale{0%{transform:scale(.9)}to{transform:scale(1)}}@keyframes floatUp{0%{transform:translateY(15%)}to{transform:translateY(0)}}@keyframes floatDown{0%{transform:translateY(-15%)}to{transform:translateY(0)}}@keyframes fade{0%{opacity:0}to{opacity:1}}.dialog{position:fixed;width:210px;padding:16px 22px 10px;font-size:1rem;font-size:var(--bucket-feedback-dialog-font-size, 1rem);font-family:InterVariable,Inter,system-ui,-apple-system,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif,Open Sans,sans-serif;font-family:var( --bucket-feedback-dialog-font-family, InterVariable, Inter, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, Open Sans, sans-serif );color:#1e1f24;color:var(--bucket-feedback-dialog-color, #1e1f24);border:1px solid;border-color:#d8d9df;border-color:var(--bucket-feedback-dialog-border, #d8d9df);border-radius:6px;border-radius:var(--bucket-feedback-dialog-border-radius, 6px);box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d;box-shadow:var( --bucket-feedback-dialog-box-shadow, 0 10px 15px -3px rgba(0, 0, 0, .1), 0 4px 6px -2px rgba(0, 0, 0, .05) );background-color:#fff;background-color:var(--bucket-feedback-dialog-background-color, #fff);z-index:2147410000}.dialog:not(.modal){margin:0;margin:initial;top:auto;top:initial;right:auto;right:initial;left:auto;left:initial;bottom:auto;bottom:initial}.arrow{position:absolute;width:8px;height:8px;background-color:#fff;background-color:var(--bucket-feedback-dialog-background-color, #fff);box-shadow:#d8d9df -1px -1px 1px;box-shadow:var(--bucket-feedback-dialog-border, #d8d9df) -1px -1px 1px 0;transform:rotate(45deg)}.arrow.bottom{box-shadow:#d8d9df -1px -1px 1px;box-shadow:var(--bucket-feedback-dialog-border, #d8d9df) -1px -1px 1px 0}.arrow.top{box-shadow:#d8d9df 1px 1px 1px;box-shadow:var(--bucket-feedback-dialog-border, #d8d9df) 1px 1px 1px 0}.arrow.left{box-shadow:#d8d9df 1px -1px 1px;box-shadow:var(--bucket-feedback-dialog-border, #d8d9df) 1px -1px 1px 0}.arrow.right{box-shadow:#d8d9df -1px 1px 1px;box-shadow:var(--bucket-feedback-dialog-border, #d8d9df) -1px 1px 1px 0}.close{position:absolute;top:6px;right:6px;width:28px;height:28px;padding:0;margin:0;background:none;border:none;cursor:pointer;display:flex;justify-content:center;align-items:center;color:#1e1f24;color:var(--bucket-feedback-dialog-color, #1e1f24)}.close svg{position:absolute}.plug{font-size:.75em;text-align:center;margin-top:7px;width:100%}.plug a{opacity:.5;color:#1e1f24;color:var(--bucket-feedback-dialog-color, #1e1f24);-webkit-text-decoration:none;text-decoration:none;transition:opacity .2s}.plug a:hover{opacity:.7}.dialog.modal{margin:auto;margin-top:4rem}.dialog.modal[open]{animation:scale .2s cubic-bezier(.22,1,.36,1),fade .2s cubic-bezier(.22,1,.36,1)}.dialog.modal[open]::backdrop{animation:fade .2s cubic-bezier(.22,1,.36,1)}.dialog.anchored{position:absolute}.dialog.anchored[open]{animation:scale .2s cubic-bezier(.22,1,.36,1),fade .2s cubic-bezier(.22,1,.36,1)}.dialog.anchored.bottom{transform-origin:top center}.dialog.anchored.top{transform-origin:bottom center}.dialog.anchored.left{transform-origin:right center}.dialog.anchored.right{transform-origin:left center}.dialog.unanchored.unanchored-bottom-left[open],.dialog.unanchored.unanchored-bottom-right[open]{animation:floatUp .3s cubic-bezier(.22,1,.36,1),fade .3s cubic-bezier(.22,1,.36,1)}.dialog.unanchored.unanchored-top-left[open],.dialog.unanchored.unanchored-top-right[open]{animation:floatDown .3s cubic-bezier(.22,1,.36,1),fade .3s cubic-bezier(.22,1,.36,1)}.container{overflow-y:hidden;transition:max-height .4s cubic-bezier(.65,0,.35,1)}.form{display:flex;flex-direction:column;align-items:flex-start;gap:10px;overflow-y:hidden;max-height:400px;transition:opacity .4s cubic-bezier(.65,0,.35,1)}.form-control{display:flex;flex-direction:column;width:100%;gap:8px;border:none;padding:0;margin:0;font-size:12px;color:#787c91;color:var(--bucket-feedback-dialog-secondary-color, #787c91)}.form-expanded-content{width:100%;display:flex;flex-direction:column;align-items:flex-start;gap:10px;transition:opacity .4s cubic-bezier(.65,0,.35,1);opacity:0;position:absolute;top:0;left:0}.title{color:#1e1f24;color:var(--bucket-feedback-dialog-color, #1e1f24);font-size:15px;font-weight:400;line-height:115%;text-wrap:balance;max-width:calc(100% - 20px);margin-bottom:6px;line-height:1.3}.dimmed{opacity:.5}.textarea{background-color:transparent;border:1px solid;border-color:#d8d9df;border-color:var(--bucket-feedback-dialog-input-border-color, #d8d9df);padding:.5rem .75rem;border-radius:6px;border-radius:var(--bucket-feedback-dialog-border-radius, 6px);transition:border-color .2s ease-in-out;font-family:InterVariable,Inter,system-ui,-apple-system,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif,Open Sans,sans-serif;font-family:var( --bucket-feedback-dialog-font-family, InterVariable, Inter, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, Open Sans, sans-serif );line-height:1.3;resize:none;color:#1e1f24;color:var(--bucket-feedback-dialog-color, #1e1f24);font-size:13px}.textarea::-moz-placeholder{color:#1e1f24;color:var(--bucket-feedback-dialog-color, #1e1f24);opacity:.36}.textarea::placeholder{color:#1e1f24;color:var(--bucket-feedback-dialog-color, #1e1f24);opacity:.36}.textarea:focus{outline:none;border-color:#787c91;border-color:var( --bucket-feedback-dialog-input-focus-border-color, #787c91 )}.score-status-container{position:relative;padding-bottom:6px;height:14px}.score-status-container>.score-status{display:flex;align-items:center;position:absolute;top:0;left:0;opacity:0;transition:opacity .2s ease-in-out}.error{margin:0;color:#e53e3e;color:var(--bucket-feedback-dialog-error-color, #e53e3e);font-size:.8125em;font-weight:500}.submitted{display:flex;flex-direction:column;transition:opacity .4s cubic-bezier(.65,0,.35,1);position:absolute;top:0;left:0;opacity:0;pointer-events:none;width:calc(100% - 56px);padding:0 28px}.submitted .submitted-check{background:#fff;background:var(--bucket-feedback-dialog-submitted-check-color, #fff);color:#38a169;color:var( --bucket-feedback-dialog-submitted-check-background-color, #38a169 );height:24px;width:24px;display:block;border-radius:50%;flex-shrink:0;display:flex;align-items:center;justify-content:center;margin:16px auto 8px}.submitted .text{margin:auto auto 16px;text-align:center;color:#1e1f24;color:var(--bucket-feedback-dialog-color, #1e1f24);font-size:1rem;font-size:var(--bucket-feedback-dialog-font-size, 1rem);font-weight:400;line-height:130%;flex-grow:1;max-width:160px}.submitted>.plug{flex-grow:0}.radial-progress>circle{stroke:#1e1f24;stroke:var(--bucket-feedback-dialog-color, #1e1f24);opacity:.2}.star-rating{display:flex;flex-direction:column}.star-rating-icons{display:flex;width:0}.star-rating-icons>input{border:0px;clip:rect(0px,0px,0px,0px);height:1px;width:1px;margin:-1px;padding:0;overflow:hidden;white-space:nowrap;position:absolute}.star-rating-icons>.button{border:1px solid;border-color:#d8d9df;border-color:var(--bucket-feedback-dialog-input-border-color, #d8d9df);padding:0 7px}.star-rating-icons>.button:not(:first-of-type){border-top-left-radius:0;border-bottom-left-radius:0}.star-rating-icons>.button:not(:last-of-type){border-top-right-radius:0;border-bottom-right-radius:0;margin-right:-1px}.star-rating-icons>.button+.button-tooltip{pointer-events:none;opacity:0;background:#000;background:var(--bucket-feedback-dialog-tooltip-background-color, #000);color:#fff;color:var(--bucket-feedback-dialog-tooltip-color, #fff);padding:6px 8px;border-radius:4px;font-size:13px}.star-rating-icons>.button:hover+.button-tooltip{opacity:1}.star-rating-icons>.button>svg{transition:transform .2s ease-in-out}.button-tooltip-arrow{position:absolute;width:10px;height:10px;background-color:#000;background-color:var( --bucket-feedback-dialog-tooltip-background-color, #000 );transform:rotate(45deg)}", Fo = ({ diameter: t, progress: e }) => {
  const o = t / 2 - 2, r = 2 * Math.PI * o, i = r * e;
  return /* @__PURE__ */ h("svg", { className: "radial-progress", width: t, height: t }, /* @__PURE__ */ h(
    "circle",
    {
      fill: "transparent",
      cx: o + 2,
      cy: o + 2,
      r: o,
      "stroke-width": 2,
      "stroke-dasharray": r,
      "stroke-dashoffset": i,
      transform: `rotate(-90) translate(-${o * 2 + 2 * 2} 0)`
    }
  ));
}, Do = 20 * 1e3, Mo = 3 * 1e3, Oo = ({
  key: t,
  title: e = De.DefaultQuestionLabel,
  position: n,
  translations: o = De,
  openWithCommentVisible: r = !1,
  onClose: i,
  onDismiss: s,
  onSubmit: c,
  onScoreSubmit: u
}) => {
  var j, F;
  const l = H(null), f = n.type === "POPOVER" ? n.anchor : null, {
    refs: a,
    floatingStyles: p,
    middlewareData: d,
    placement: m
  } = en({
    elements: {
      reference: f
    },
    transform: !1,
    whileElementsMounted: ho,
    middleware: [
      po(),
      Qt(8),
      Xt({
        element: l
      })
    ]
  });
  let y = {};
  if (n.type === "DIALOG") {
    const R = Ct((j = n.offset) == null ? void 0 : j.y), k = Ct((F = n.offset) == null ? void 0 : F.x);
    switch (n.placement) {
      case "top-left":
        y = {
          top: R,
          left: k
        };
        break;
      case "top-right":
        y = {
          top: R,
          right: k
        };
        break;
      case "bottom-left":
        y = {
          bottom: R,
          left: k
        };
        break;
      case "bottom-right":
        y = {
          bottom: R,
          right: k
        };
        break;
    }
  }
  const { x: _, y: g } = d.arrow ?? {}, b = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
  }[m.split("-")[0]] || "bottom", v = {
    left: _ != null ? `${_}px` : "",
    top: g != null ? `${g}px` : "",
    right: "",
    bottom: "",
    [b]: "-4px"
  }, w = z(() => {
    const R = a.floating.current;
    R == null || R.close(), P.stop(), i == null || i();
  }, [i]), x = z(() => {
    w(), s == null || s();
  }, [w, s]), [C, A] = M(void 0), [T, D] = M("idle"), S = z(
    async (R) => {
      await c({ ...R, feedbackId: C }), P.startWithDuration(Mo);
    },
    [C, c]
  ), O = z(
    async (R) => {
      if (u !== void 0) {
        D("submitting");
        const k = await u({ ...R, feedbackId: C });
        A(k.feedbackId), D("submitted");
      }
    },
    [C, c]
  ), P = zn({
    enabled: n.type === "DIALOG",
    initialDuration: Do,
    onEnd: w
  });
  return Ee(() => {
    if (n.type === "MODAL" || n.type === "DIALOG") return;
    const R = (N) => {
      N.key == "Escape" && x();
    }, k = (N) => {
      (!(N.target instanceof Element) || !N.target.closest(`#${ze}`)) && x();
    }, U = new MutationObserver((N) => {
      n.anchor !== null && N.forEach((rn) => {
        Array.from(rn.removedNodes).some((Ge) => Ge === n.anchor || Ge.contains(n.anchor)) && w();
      });
    });
    return window.addEventListener("mousedown", k), window.addEventListener("keydown", R), U.observe(document.body, {
      subtree: !0,
      childList: !0
    }), () => {
      window.removeEventListener("mousedown", k), window.removeEventListener("keydown", R), U.disconnect();
    };
  }, [n.type, w]), /* @__PURE__ */ h(ie, null, /* @__PURE__ */ h("style", { dangerouslySetInnerHTML: { __html: To } }), /* @__PURE__ */ h(
    "dialog",
    {
      ref: a.setFloating,
      class: [
        "dialog",
        n.type === "MODAL" ? "modal" : n.type === "POPOVER" ? "anchored" : `unanchored unanchored-${n.placement}`,
        m
      ].join(" "),
      style: f ? p : y
    },
    /* @__PURE__ */ h(
      Lo,
      {
        t: { ...De, ...o },
        key: t,
        question: e,
        openWithCommentVisible: r,
        onSubmit: S,
        onScoreSubmit: O,
        scoreState: T,
        onInteraction: P.stop
      }
    ),
    /* @__PURE__ */ h("button", { onClick: x, class: "close" }, !P.stopped && P.elapsedFraction > 0 && /* @__PURE__ */ h(
      Fo,
      {
        diameter: 28,
        progress: 1 - P.elapsedFraction
      }
    ), /* @__PURE__ */ h(Un, null)),
    f && /* @__PURE__ */ h(
      "div",
      {
        ref: l,
        class: ["arrow", m].join(" "),
        style: v
      }
    )
  ));
};
function Ct(t) {
  return t === void 0 ? "1rem" : typeof t == "number" ? t + "px" : t;
}
const tn = {
  type: "DIALOG",
  placement: "bottom-right"
};
function Po(t) {
  t.stopPropagation();
}
function No() {
  let t = document.querySelector(`#${ze}`);
  if (!t) {
    t = document.createElement("div"), t.attachShadow({ mode: "open" }), t.style.all = "initial", t.id = ze, document.body.appendChild(t);
    for (const e of Pn)
      t.addEventListener(e, Po);
  }
  return t.shadowRoot;
}
function nn(t) {
  const e = No(), n = t.position || tn;
  if (n.type === "POPOVER") {
    if (!n.anchor) {
      console.warn(
        "[Bucket]",
        "Unable to open popover. Anchor must be a defined DOM-element"
      );
      return;
    }
    if (!document.body.contains(n.anchor)) {
      console.warn(
        "[Bucket]",
        "Unable to open popover. Anchor must be an attached DOM-element"
      );
      return;
    }
  }
  On(h(Oo, { ...t, position: n }), e);
  const o = e.querySelector("dialog");
  o && !o.hasAttribute("open") && o[n.type === "MODAL" ? "showModal" : "show"]();
}
function $o(t) {
  return {
    ...t,
    enableAutoFeedback: (t == null ? void 0 : t.enableAutoFeedback) ?? (t == null ? void 0 : t.enableLiveSatisfaction),
    autoFeedbackHandler: (t == null ? void 0 : t.autoFeedbackHandler) ?? (t == null ? void 0 : t.liveSatisfactionHandler)
  };
}
const Ho = (t = {}) => (e, n) => {
  n.openFeedbackForm(t);
};
async function on(t, e, n) {
  if (!n.score && !n.comment) {
    e.error("either 'score' or 'comment' must be provided");
    return;
  }
  if (!n.userId) {
    e.error("`feedback` call ignored, no user id given");
    return;
  }
  const o = {
    ...n,
    source: n.source ?? "sdk"
  }, r = await t.post({
    path: "/feedback",
    body: o
  });
  return e.debug("sent feedback", r), r;
}
class zo {
  constructor(e, n, o, r = Ho(), i, s = tn, c = {}) {
    this.sseHost = e, this.logger = n, this.httpClient = o, this.feedbackPromptHandler = r, this.userId = i, this.position = s, this.feedbackTranslations = c, this.initialized = !1, this.sseChannel = null;
  }
  /**
   * Start receiving automated feedback surveys.
   */
  async initialize() {
    if (this.initialized) {
      this.logger.error("auto. feedback client already initialized");
      return;
    }
    this.initialized = !0;
    const e = await this.getChannel();
    if (e)
      try {
        this.logger.debug("auto. feedback enabled", e), this.sseChannel = Rn({
          userId: this.userId,
          channel: e,
          httpClient: this.httpClient,
          callback: (n) => this.handleFeedbackPromptRequest(this.userId, n),
          logger: this.logger,
          sseHost: this.sseHost
        }), this.logger.debug("auto. feedback connection established");
      } catch (n) {
        this.logger.error("error initializing auto. feedback client", n);
      }
  }
  async getChannel() {
    const e = Lt(this.userId), n = e == null ? void 0 : e.channel;
    if (n)
      return n;
    try {
      if (!n) {
        const o = await this.httpClient.post({
          path: "/feedback/prompting-init",
          body: {
            userId: this.userId
          }
        });
        if (this.logger.debug("auto. feedback status sent", o), o.ok) {
          const r = await o.json();
          if (r.success && r.channel)
            return r.channel;
        }
      }
    } catch (o) {
      this.logger.error("error initializing auto. feedback", o);
      return;
    }
  }
  handleFeedbackPromptRequest(e, n) {
    const o = In(n);
    o ? Ln(e, o, async (r, i, s) => {
      await this.feedbackPromptEvent({
        promptId: o.promptId,
        featureId: o.featureId,
        promptedQuestion: o.question,
        event: "received",
        userId: e
      }), await this.triggerFeedbackPrompt(r, i, s);
    }) || this.logger.info(
      "feedback prompt not shown, it was either expired or already processed",
      n
    ) : this.logger.error("invalid feedback prompt message received", n);
  }
  stop() {
    this.sseChannel && (this.sseChannel.close(), this.sseChannel = null);
  }
  async triggerFeedbackPrompt(e, n, o) {
    let r;
    await this.feedbackPromptEvent({
      promptId: n.promptId,
      featureId: n.featureId,
      promptedQuestion: n.question,
      event: "shown",
      userId: e
    });
    const i = async (c) => {
      if (!c) {
        await this.feedbackPromptEvent({
          promptId: n.promptId,
          featureId: n.featureId,
          event: "dismissed",
          userId: e,
          promptedQuestion: n.question
        }), o();
        return;
      }
      const u = {
        feedbackId: r,
        featureId: n.featureId,
        userId: e,
        companyId: c.companyId,
        score: c.score,
        comment: c.comment,
        promptId: n.promptId,
        question: c.question,
        promptedQuestion: n.question,
        source: "prompt"
      }, l = await on(
        this.httpClient,
        this.logger,
        u
      );
      if (o(), l && l.ok)
        return await (l == null ? void 0 : l.json());
    }, s = {
      reply: i,
      openFeedbackForm: (c) => {
        nn({
          key: n.featureId,
          title: n.question,
          onScoreSubmit: async (u) => {
            const l = await i(u);
            return r = l.feedbackId, { feedbackId: l.feedbackId };
          },
          onSubmit: async (u) => {
            var l;
            await i(u), (l = c.onAfterSubmit) == null || l.call(c, u);
          },
          onDismiss: () => i(null),
          position: this.position,
          translations: this.feedbackTranslations,
          ...c
        });
      }
    };
    this.feedbackPromptHandler(n, s);
  }
  async feedbackPromptEvent(e) {
    const n = {
      action: e.event,
      featureId: e.featureId,
      promptId: e.promptId,
      userId: e.userId,
      promptedQuestion: e.promptedQuestion
    }, o = await this.httpClient.post({
      path: "/feedback/prompt-events",
      body: n
    });
    return this.logger.debug("sent prompt event", o), o;
  }
}
class Uo {
  constructor(e, n = {}) {
    this.publishableKey = e, this.baseUrl = n.baseUrl ?? Et, this.baseUrl.endsWith("/") || (this.baseUrl += "/"), this.sdkVersion = n.sdkVersion ?? cn;
  }
  getUrl(e) {
    return e.startsWith("/") && (e = e.slice(1)), new URL(e, this.baseUrl);
  }
  async get({
    path: e,
    params: n,
    timeoutMs: o
  }) {
    n || (n = new URLSearchParams()), n.set(et, this.sdkVersion), n.set("publishableKey", this.publishableKey);
    const r = this.getUrl(e);
    if (r.search = n.toString(), o === void 0)
      return fetch(r);
    const i = new AbortController(), s = setTimeout(() => i.abort(), o), c = await fetch(r, {
      signal: i.signal
    });
    return clearTimeout(s), c;
  }
  async post({
    path: e,
    body: n
  }) {
    return fetch(this.getUrl(e), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        [et]: this.sdkVersion,
        Authorization: `Bearer ${this.publishableKey}`
      },
      body: JSON.stringify(n)
    });
  }
}
const Bo = typeof window < "u" && window.innerWidth < 768, St = {
  host: Et,
  sseHost: an
};
class qo {
  constructor(e) {
    var o, r, i, s, c, u;
    this.publishableKey = e.publishableKey, this.logger = (e == null ? void 0 : e.logger) ?? Ve(un, "[Bucket]"), this.context = {
      user: e == null ? void 0 : e.user,
      company: e == null ? void 0 : e.company,
      otherContext: e == null ? void 0 : e.otherContext
    }, this.config = {
      host: (e == null ? void 0 : e.host) ?? St.host,
      sseHost: (e == null ? void 0 : e.sseHost) ?? St.sseHost
    };
    const n = $o(e == null ? void 0 : e.feedback);
    this.requestFeedbackOptions = {
      position: (o = n == null ? void 0 : n.ui) == null ? void 0 : o.position,
      translations: (r = n == null ? void 0 : n.ui) == null ? void 0 : r.translations
    }, this.httpClient = new Uo(this.publishableKey, {
      baseUrl: this.config.host,
      sdkVersion: e == null ? void 0 : e.sdkVersion
    }), this.featuresClient = new bn(
      this.httpClient,
      // API expects `other` and we have `otherContext`.
      {
        user: this.context.user,
        company: this.context.company,
        other: this.context.otherContext
      },
      this.logger,
      e == null ? void 0 : e.features
    ), (i = this.context) != null && i.user && (n == null ? void 0 : n.enableAutoFeedback) !== !1 && (Bo ? this.logger.warn(
      "Feedback prompting is not supported on mobile devices"
    ) : this.autoFeedback = new zo(
      this.config.sseHost,
      this.logger,
      this.httpClient,
      n == null ? void 0 : n.autoFeedbackHandler,
      String((s = this.context.user) == null ? void 0 : s.id),
      (c = n == null ? void 0 : n.ui) == null ? void 0 : c.position,
      (u = n == null ? void 0 : n.ui) == null ? void 0 : u.translations
    ));
  }
  /**
   * Initialize the Bucket SDK.
   *
   * Must be called before calling other SDK methods.
   */
  async initialize() {
    this.autoFeedback && (this.autoFeedbackInit = this.autoFeedback.initialize().catch((e) => {
      this.logger.error("error initializing automated feedback surveys", e);
    })), await this.featuresClient.initialize(), this.context.user && this.user().catch((e) => {
      this.logger.error("error sending user", e);
    }), this.context.company && this.company().catch((e) => {
      this.logger.error("error sending company", e);
    }), this.logger.debug(
      `initialized with key "${this.publishableKey}" and options`,
      this.config
    );
  }
  /**
   * Send attributes to Bucket for the current user
   */
  async user() {
    if (!this.context.user) {
      this.logger.warn(
        "`user` call ignored. No user context provided at initialization"
      );
      return;
    }
    const { id: e, ...n } = this.context.user, o = {
      userId: String(e),
      attributes: n
    }, r = await this.httpClient.post({ path: "/user", body: o });
    return this.logger.debug("sent user", r), r;
  }
  /**
   * Send attributes to Bucket for the current company.
   */
  async company() {
    if (!this.context.user) {
      this.logger.warn(
        "`company` call ignored. No user context provided at initialization"
      );
      return;
    }
    if (!this.context.company) {
      this.logger.warn(
        "`company` call ignored. No company context provided at initialization"
      );
      return;
    }
    const { id: e, ...n } = this.context.company, o = {
      userId: String(this.context.user.id),
      companyId: String(e),
      attributes: n
    }, r = await this.httpClient.post({ path: "/company", body: o });
    return this.logger.debug("sent company", r), r;
  }
  /**
   * Track an event in Bucket.
   *
   * @param eventName The name of the event
   * @param attributes Any attributes you want to attach to the event
   */
  async track(e, n) {
    var i, s;
    if (!this.context.user) {
      this.logger.debug("'track' call ignore. No user context provided");
      return;
    }
    const o = {
      userId: String(this.context.user.id),
      event: e
    };
    n && (o.attributes = n), (i = this.context.company) != null && i.id && (o.companyId = String((s = this.context.company) == null ? void 0 : s.id));
    const r = await this.httpClient.post({ path: "/event", body: o });
    return this.logger.debug("sent event", r), r;
  }
  /**
   * Submit user feedback to Bucket. Must include either `score` or `comment`, or both.
   *
   * @param options
   * @returns
   */
  async feedback(e) {
    var r, i, s, c;
    const n = e.userId || ((r = this.context.user) != null && r.id ? String((i = this.context.user) == null ? void 0 : i.id) : void 0), o = e.companyId || ((s = this.context.company) != null && s.id ? String((c = this.context.company) == null ? void 0 : c.id) : void 0);
    return await on(this.httpClient, this.logger, {
      userId: n,
      companyId: o,
      ...e
    });
  }
  /**
   * Display the Bucket feedback form UI programmatically.
   *
   * This can be used to collect feedback from users in Bucket in cases where Automated Feedback Surveys isn't appropriate.
   *
   * @param options
   */
  requestFeedback(e) {
    var o, r, i;
    if (!((o = this.context.user) != null && o.id)) {
      this.logger.error(
        "`requestFeedback` call ignored. No user context provided at initialization"
      );
      return;
    }
    const n = {
      featureId: e.featureId,
      companyId: e.companyId || ((r = this.context.company) != null && r.id ? String((i = this.context.company) == null ? void 0 : i.id) : void 0),
      source: "widget"
    };
    setTimeout(() => {
      nn({
        key: e.featureId,
        title: e.title,
        position: e.position || this.requestFeedbackOptions.position,
        translations: e.translations || this.requestFeedbackOptions.translations,
        openWithCommentVisible: e.openWithCommentVisible,
        onClose: e.onClose,
        onDismiss: e.onDismiss,
        onScoreSubmit: async (s) => {
          const c = await this.feedback({
            ...n,
            ...s
          });
          return c ? { feedbackId: (await c.json()).feedbackId } : { feedbackId: void 0 };
        },
        onSubmit: async (s) => {
          var c;
          await this.feedback({
            ...n,
            ...s
          }), (c = e.onAfterSubmit) == null || c.call(e, s);
        }
      });
    }, 1);
  }
  /**
   * Returns a map of enabled features.
   * Accessing a feature will *not* send a check event
   *
   * @returns Map of features
   */
  getFeatures() {
    return this.featuresClient.getFeatures();
  }
  /**
   * Return a feature. Accessing `isEnabled` will automatically send a `check` event.
   * @returns A feature
   */
  getFeature(e) {
    const n = this.getFeatures()[e], o = this.featuresClient, r = (n == null ? void 0 : n.isEnabled) ?? !1;
    return {
      get isEnabled() {
        return o.sendCheckEvent({
          key: e,
          version: n == null ? void 0 : n.targetingVersion,
          value: r
        }).catch(() => {
        }), r;
      },
      track: () => this.track(e)
    };
  }
  sendCheckEvent(e) {
    return this.featuresClient.sendCheckEvent(e);
  }
  /**
   * Stop the SDK. This will stop any automated feedback surveys.
   *
   **/
  async stop() {
    this.autoFeedback && (await this.autoFeedbackInit, this.autoFeedback.stop());
  }
}
export {
  qo as BucketClient,
  ze as feedbackContainerId,
  Pn as propagatedEvents
};
//# sourceMappingURL=bucket-browser-sdk.mjs.map
